// source: messages.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.fbproto.AddDevice', null, global);
goog.exportSymbol('proto.fbproto.AddTrigger', null, global);
goog.exportSymbol('proto.fbproto.BLEWrapper', null, global);
goog.exportSymbol('proto.fbproto.BLEWrapper.ContentCase', null, global);
goog.exportSymbol('proto.fbproto.BLEWrapper.MessageType', null, global);
goog.exportSymbol('proto.fbproto.CalibratePh', null, global);
goog.exportSymbol('proto.fbproto.CalibratePhResponse', null, global);
goog.exportSymbol('proto.fbproto.ControllerType', null, global);
goog.exportSymbol('proto.fbproto.Device', null, global);
goog.exportSymbol('proto.fbproto.DeviceAssembly', null, global);
goog.exportSymbol('proto.fbproto.DeviceAssemblyType', null, global);
goog.exportSymbol('proto.fbproto.DeviceAttached', null, global);
goog.exportSymbol('proto.fbproto.DeviceRemoved', null, global);
goog.exportSymbol('proto.fbproto.DeviceType', null, global);
goog.exportSymbol('proto.fbproto.Error', null, global);
goog.exportSymbol('proto.fbproto.GenerateFakeSensorReading', null, global);
goog.exportSymbol('proto.fbproto.GetDeviceAssembliesDevices', null, global);
goog.exportSymbol('proto.fbproto.GetDeviceAssembliesDevicesResponse', null, global);
goog.exportSymbol('proto.fbproto.GetDevices', null, global);
goog.exportSymbol('proto.fbproto.GetDevicesResponse', null, global);
goog.exportSymbol('proto.fbproto.GetFlows', null, global);
goog.exportSymbol('proto.fbproto.GetFlowsResponse', null, global);
goog.exportSymbol('proto.fbproto.GetPhCalibration', null, global);
goog.exportSymbol('proto.fbproto.GetPhCalibrationResponse', null, global);
goog.exportSymbol('proto.fbproto.MessageWrapper', null, global);
goog.exportSymbol('proto.fbproto.MessageWrapper.ContentCase', null, global);
goog.exportSymbol('proto.fbproto.MessageWrapper.MessageType', null, global);
goog.exportSymbol('proto.fbproto.NodeType', null, global);
goog.exportSymbol('proto.fbproto.OtaUpdateComplete', null, global);
goog.exportSymbol('proto.fbproto.OtaUpdateCompleteResponse', null, global);
goog.exportSymbol('proto.fbproto.OtaUpdateFile', null, global);
goog.exportSymbol('proto.fbproto.OtaUpdateFileResponse', null, global);
goog.exportSymbol('proto.fbproto.OtaUpdateInit', null, global);
goog.exportSymbol('proto.fbproto.OtaUpdateInitResponse', null, global);
goog.exportSymbol('proto.fbproto.ReadingType', null, global);
goog.exportSymbol('proto.fbproto.ReloadFlows', null, global);
goog.exportSymbol('proto.fbproto.ReloadFlowsResponse', null, global);
goog.exportSymbol('proto.fbproto.RemoveDevice', null, global);
goog.exportSymbol('proto.fbproto.RemoveTrigger', null, global);
goog.exportSymbol('proto.fbproto.Response', null, global);
goog.exportSymbol('proto.fbproto.RestartController', null, global);
goog.exportSymbol('proto.fbproto.RestartControllerResponse', null, global);
goog.exportSymbol('proto.fbproto.RunDevice', null, global);
goog.exportSymbol('proto.fbproto.RunDeviceResponse', null, global);
goog.exportSymbol('proto.fbproto.SensorReading', null, global);
goog.exportSymbol('proto.fbproto.SensorReading.RawReadingCase', null, global);
goog.exportSymbol('proto.fbproto.SensorReading.ReadingCase', null, global);
goog.exportSymbol('proto.fbproto.SetControllerId', null, global);
goog.exportSymbol('proto.fbproto.SetEncKey', null, global);
goog.exportSymbol('proto.fbproto.SetMqttPassword', null, global);
goog.exportSymbol('proto.fbproto.SetParam', null, global);
goog.exportSymbol('proto.fbproto.SetParam.ParamCase', null, global);
goog.exportSymbol('proto.fbproto.SetWifiParams', null, global);
goog.exportSymbol('proto.fbproto.TriggerType', null, global);
goog.exportSymbol('proto.fbproto.UuidV8', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fbproto.UuidV8 = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fbproto.UuidV8, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fbproto.UuidV8.displayName = 'proto.fbproto.UuidV8';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fbproto.Device = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fbproto.Device, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fbproto.Device.displayName = 'proto.fbproto.Device';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fbproto.DeviceAssembly = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fbproto.DeviceAssembly.repeatedFields_, null);
};
goog.inherits(proto.fbproto.DeviceAssembly, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fbproto.DeviceAssembly.displayName = 'proto.fbproto.DeviceAssembly';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fbproto.MessageWrapper = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.fbproto.MessageWrapper.oneofGroups_);
};
goog.inherits(proto.fbproto.MessageWrapper, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fbproto.MessageWrapper.displayName = 'proto.fbproto.MessageWrapper';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fbproto.Response = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fbproto.Response, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fbproto.Response.displayName = 'proto.fbproto.Response';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fbproto.SensorReading = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.fbproto.SensorReading.oneofGroups_);
};
goog.inherits(proto.fbproto.SensorReading, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fbproto.SensorReading.displayName = 'proto.fbproto.SensorReading';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fbproto.DeviceAttached = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fbproto.DeviceAttached, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fbproto.DeviceAttached.displayName = 'proto.fbproto.DeviceAttached';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fbproto.DeviceRemoved = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fbproto.DeviceRemoved, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fbproto.DeviceRemoved.displayName = 'proto.fbproto.DeviceRemoved';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fbproto.SetParam = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.fbproto.SetParam.oneofGroups_);
};
goog.inherits(proto.fbproto.SetParam, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fbproto.SetParam.displayName = 'proto.fbproto.SetParam';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fbproto.CalibratePh = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fbproto.CalibratePh, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fbproto.CalibratePh.displayName = 'proto.fbproto.CalibratePh';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fbproto.CalibratePhResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fbproto.CalibratePhResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fbproto.CalibratePhResponse.displayName = 'proto.fbproto.CalibratePhResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fbproto.RestartController = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fbproto.RestartController, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fbproto.RestartController.displayName = 'proto.fbproto.RestartController';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fbproto.RestartControllerResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fbproto.RestartControllerResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fbproto.RestartControllerResponse.displayName = 'proto.fbproto.RestartControllerResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fbproto.OtaUpdateInit = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fbproto.OtaUpdateInit, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fbproto.OtaUpdateInit.displayName = 'proto.fbproto.OtaUpdateInit';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fbproto.OtaUpdateInitResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fbproto.OtaUpdateInitResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fbproto.OtaUpdateInitResponse.displayName = 'proto.fbproto.OtaUpdateInitResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fbproto.OtaUpdateFile = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fbproto.OtaUpdateFile, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fbproto.OtaUpdateFile.displayName = 'proto.fbproto.OtaUpdateFile';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fbproto.OtaUpdateFileResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fbproto.OtaUpdateFileResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fbproto.OtaUpdateFileResponse.displayName = 'proto.fbproto.OtaUpdateFileResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fbproto.OtaUpdateComplete = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fbproto.OtaUpdateComplete, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fbproto.OtaUpdateComplete.displayName = 'proto.fbproto.OtaUpdateComplete';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fbproto.OtaUpdateCompleteResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fbproto.OtaUpdateCompleteResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fbproto.OtaUpdateCompleteResponse.displayName = 'proto.fbproto.OtaUpdateCompleteResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fbproto.ReloadFlows = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fbproto.ReloadFlows, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fbproto.ReloadFlows.displayName = 'proto.fbproto.ReloadFlows';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fbproto.ReloadFlowsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fbproto.ReloadFlowsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fbproto.ReloadFlowsResponse.displayName = 'proto.fbproto.ReloadFlowsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fbproto.RunDevice = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fbproto.RunDevice, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fbproto.RunDevice.displayName = 'proto.fbproto.RunDevice';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fbproto.RunDeviceResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fbproto.RunDeviceResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fbproto.RunDeviceResponse.displayName = 'proto.fbproto.RunDeviceResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fbproto.GetDevices = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fbproto.GetDevices, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fbproto.GetDevices.displayName = 'proto.fbproto.GetDevices';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fbproto.GetDevicesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fbproto.GetDevicesResponse.repeatedFields_, null);
};
goog.inherits(proto.fbproto.GetDevicesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fbproto.GetDevicesResponse.displayName = 'proto.fbproto.GetDevicesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fbproto.GetFlows = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fbproto.GetFlows, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fbproto.GetFlows.displayName = 'proto.fbproto.GetFlows';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fbproto.GetFlowsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fbproto.GetFlowsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fbproto.GetFlowsResponse.displayName = 'proto.fbproto.GetFlowsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fbproto.GetPhCalibration = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fbproto.GetPhCalibration, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fbproto.GetPhCalibration.displayName = 'proto.fbproto.GetPhCalibration';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fbproto.GetPhCalibrationResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fbproto.GetPhCalibrationResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fbproto.GetPhCalibrationResponse.displayName = 'proto.fbproto.GetPhCalibrationResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fbproto.GetDeviceAssembliesDevices = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fbproto.GetDeviceAssembliesDevices, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fbproto.GetDeviceAssembliesDevices.displayName = 'proto.fbproto.GetDeviceAssembliesDevices';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fbproto.GetDeviceAssembliesDevicesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.fbproto.GetDeviceAssembliesDevicesResponse.repeatedFields_, null);
};
goog.inherits(proto.fbproto.GetDeviceAssembliesDevicesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fbproto.GetDeviceAssembliesDevicesResponse.displayName = 'proto.fbproto.GetDeviceAssembliesDevicesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fbproto.GenerateFakeSensorReading = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fbproto.GenerateFakeSensorReading, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fbproto.GenerateFakeSensorReading.displayName = 'proto.fbproto.GenerateFakeSensorReading';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fbproto.BLEWrapper = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.fbproto.BLEWrapper.oneofGroups_);
};
goog.inherits(proto.fbproto.BLEWrapper, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fbproto.BLEWrapper.displayName = 'proto.fbproto.BLEWrapper';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fbproto.SetWifiParams = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fbproto.SetWifiParams, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fbproto.SetWifiParams.displayName = 'proto.fbproto.SetWifiParams';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fbproto.SetControllerId = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fbproto.SetControllerId, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fbproto.SetControllerId.displayName = 'proto.fbproto.SetControllerId';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fbproto.SetMqttPassword = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fbproto.SetMqttPassword, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fbproto.SetMqttPassword.displayName = 'proto.fbproto.SetMqttPassword';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fbproto.AddDevice = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fbproto.AddDevice, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fbproto.AddDevice.displayName = 'proto.fbproto.AddDevice';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fbproto.RemoveDevice = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fbproto.RemoveDevice, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fbproto.RemoveDevice.displayName = 'proto.fbproto.RemoveDevice';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fbproto.AddTrigger = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fbproto.AddTrigger, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fbproto.AddTrigger.displayName = 'proto.fbproto.AddTrigger';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fbproto.RemoveTrigger = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fbproto.RemoveTrigger, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fbproto.RemoveTrigger.displayName = 'proto.fbproto.RemoveTrigger';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.fbproto.SetEncKey = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.fbproto.SetEncKey, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.fbproto.SetEncKey.displayName = 'proto.fbproto.SetEncKey';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fbproto.UuidV8.prototype.toObject = function(opt_includeInstance) {
  return proto.fbproto.UuidV8.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fbproto.UuidV8} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.UuidV8.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fbproto.UuidV8}
 */
proto.fbproto.UuidV8.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fbproto.UuidV8;
  return proto.fbproto.UuidV8.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fbproto.UuidV8} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fbproto.UuidV8}
 */
proto.fbproto.UuidV8.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fbproto.UuidV8.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fbproto.UuidV8.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fbproto.UuidV8} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.UuidV8.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fbproto.Device.prototype.toObject = function(opt_includeInstance) {
  return proto.fbproto.Device.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fbproto.Device} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.Device.toObject = function(includeInstance, msg) {
  var f, obj = {
deviceId: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
deviceType: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
subportNumber: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fbproto.Device}
 */
proto.fbproto.Device.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fbproto.Device;
  return proto.fbproto.Device.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fbproto.Device} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fbproto.Device}
 */
proto.fbproto.Device.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDeviceId(value);
      break;
    case 2:
      var value = /** @type {!proto.fbproto.NodeType} */ (reader.readEnum());
      msg.setDeviceType(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSubportNumber(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fbproto.Device.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fbproto.Device.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fbproto.Device} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.Device.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = /** @type {!proto.fbproto.NodeType} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeInt32(
      5,
      f
    );
  }
};


/**
 * optional int64 device_id = 1;
 * @return {number}
 */
proto.fbproto.Device.prototype.getDeviceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.fbproto.Device} returns this
 */
proto.fbproto.Device.prototype.setDeviceId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.Device} returns this
 */
proto.fbproto.Device.prototype.clearDeviceId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.Device.prototype.hasDeviceId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional NodeType device_type = 2;
 * @return {!proto.fbproto.NodeType}
 */
proto.fbproto.Device.prototype.getDeviceType = function() {
  return /** @type {!proto.fbproto.NodeType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.fbproto.NodeType} value
 * @return {!proto.fbproto.Device} returns this
 */
proto.fbproto.Device.prototype.setDeviceType = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.Device} returns this
 */
proto.fbproto.Device.prototype.clearDeviceType = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.Device.prototype.hasDeviceType = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int32 subport_number = 5;
 * @return {number}
 */
proto.fbproto.Device.prototype.getSubportNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.fbproto.Device} returns this
 */
proto.fbproto.Device.prototype.setSubportNumber = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.Device} returns this
 */
proto.fbproto.Device.prototype.clearSubportNumber = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.Device.prototype.hasSubportNumber = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fbproto.DeviceAssembly.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fbproto.DeviceAssembly.prototype.toObject = function(opt_includeInstance) {
  return proto.fbproto.DeviceAssembly.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fbproto.DeviceAssembly} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.DeviceAssembly.toObject = function(includeInstance, msg) {
  var f, obj = {
deviceAssemblyId: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
deviceAssemblyType: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
controllerId: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
portNumber: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
devicesList: jspb.Message.toObjectList(msg.getDevicesList(),
    proto.fbproto.Device.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fbproto.DeviceAssembly}
 */
proto.fbproto.DeviceAssembly.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fbproto.DeviceAssembly;
  return proto.fbproto.DeviceAssembly.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fbproto.DeviceAssembly} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fbproto.DeviceAssembly}
 */
proto.fbproto.DeviceAssembly.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDeviceAssemblyId(value);
      break;
    case 2:
      var value = /** @type {!proto.fbproto.DeviceAssemblyType} */ (reader.readEnum());
      msg.setDeviceAssemblyType(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setControllerId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPortNumber(value);
      break;
    case 5:
      var value = new proto.fbproto.Device;
      reader.readMessage(value,proto.fbproto.Device.deserializeBinaryFromReader);
      msg.addDevices(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fbproto.DeviceAssembly.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fbproto.DeviceAssembly.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fbproto.DeviceAssembly} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.DeviceAssembly.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = /** @type {!proto.fbproto.DeviceAssemblyType} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getDevicesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.fbproto.Device.serializeBinaryToWriter
    );
  }
};


/**
 * optional int64 device_assembly_id = 1;
 * @return {number}
 */
proto.fbproto.DeviceAssembly.prototype.getDeviceAssemblyId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.fbproto.DeviceAssembly} returns this
 */
proto.fbproto.DeviceAssembly.prototype.setDeviceAssemblyId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.DeviceAssembly} returns this
 */
proto.fbproto.DeviceAssembly.prototype.clearDeviceAssemblyId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.DeviceAssembly.prototype.hasDeviceAssemblyId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional DeviceAssemblyType device_assembly_type = 2;
 * @return {!proto.fbproto.DeviceAssemblyType}
 */
proto.fbproto.DeviceAssembly.prototype.getDeviceAssemblyType = function() {
  return /** @type {!proto.fbproto.DeviceAssemblyType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.fbproto.DeviceAssemblyType} value
 * @return {!proto.fbproto.DeviceAssembly} returns this
 */
proto.fbproto.DeviceAssembly.prototype.setDeviceAssemblyType = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.DeviceAssembly} returns this
 */
proto.fbproto.DeviceAssembly.prototype.clearDeviceAssemblyType = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.DeviceAssembly.prototype.hasDeviceAssemblyType = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 controller_id = 3;
 * @return {number}
 */
proto.fbproto.DeviceAssembly.prototype.getControllerId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.fbproto.DeviceAssembly} returns this
 */
proto.fbproto.DeviceAssembly.prototype.setControllerId = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.DeviceAssembly} returns this
 */
proto.fbproto.DeviceAssembly.prototype.clearControllerId = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.DeviceAssembly.prototype.hasControllerId = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional int32 port_number = 4;
 * @return {number}
 */
proto.fbproto.DeviceAssembly.prototype.getPortNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.fbproto.DeviceAssembly} returns this
 */
proto.fbproto.DeviceAssembly.prototype.setPortNumber = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.DeviceAssembly} returns this
 */
proto.fbproto.DeviceAssembly.prototype.clearPortNumber = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.DeviceAssembly.prototype.hasPortNumber = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * repeated Device devices = 5;
 * @return {!Array<!proto.fbproto.Device>}
 */
proto.fbproto.DeviceAssembly.prototype.getDevicesList = function() {
  return /** @type{!Array<!proto.fbproto.Device>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fbproto.Device, 5));
};


/**
 * @param {!Array<!proto.fbproto.Device>} value
 * @return {!proto.fbproto.DeviceAssembly} returns this
*/
proto.fbproto.DeviceAssembly.prototype.setDevicesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.fbproto.Device=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fbproto.Device}
 */
proto.fbproto.DeviceAssembly.prototype.addDevices = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.fbproto.Device, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fbproto.DeviceAssembly} returns this
 */
proto.fbproto.DeviceAssembly.prototype.clearDevicesList = function() {
  return this.setDevicesList([]);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.fbproto.MessageWrapper.oneofGroups_ = [[21,22,23,24,27,28,29,30,31,32,33,34,35,36,37,38,39,40,101,102,103,104,105,106,107,108,128]];

/**
 * @enum {number}
 */
proto.fbproto.MessageWrapper.ContentCase = {
  CONTENT_NOT_SET: 0,
  SR: 21,
  DA: 22,
  DR: 23,
  SP: 24,
  CP: 27,
  CPR: 28,
  RC: 29,
  RCR: 30,
  OTI: 31,
  OTIR: 32,
  OTF: 33,
  OTFR: 34,
  OTC: 35,
  OTCR: 36,
  RF: 37,
  RFR: 38,
  RD: 39,
  RDR: 40,
  GD: 101,
  GDR: 102,
  GF: 103,
  GFR: 104,
  GPC: 105,
  GPCR: 106,
  GDAD: 107,
  GDADR: 108,
  GFSR: 128
};

/**
 * @return {proto.fbproto.MessageWrapper.ContentCase}
 */
proto.fbproto.MessageWrapper.prototype.getContentCase = function() {
  return /** @type {proto.fbproto.MessageWrapper.ContentCase} */(jspb.Message.computeOneofCase(this, proto.fbproto.MessageWrapper.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fbproto.MessageWrapper.prototype.toObject = function(opt_includeInstance) {
  return proto.fbproto.MessageWrapper.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fbproto.MessageWrapper} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.MessageWrapper.toObject = function(includeInstance, msg) {
  var f, obj = {
messageType: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
messageId: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
response: (f = msg.getResponse()) && proto.fbproto.Response.toObject(includeInstance, f),
sr: (f = msg.getSr()) && proto.fbproto.SensorReading.toObject(includeInstance, f),
da: (f = msg.getDa()) && proto.fbproto.DeviceAttached.toObject(includeInstance, f),
dr: (f = msg.getDr()) && proto.fbproto.DeviceRemoved.toObject(includeInstance, f),
sp: (f = msg.getSp()) && proto.fbproto.SetParam.toObject(includeInstance, f),
cp: (f = msg.getCp()) && proto.fbproto.CalibratePh.toObject(includeInstance, f),
cpr: (f = msg.getCpr()) && proto.fbproto.CalibratePhResponse.toObject(includeInstance, f),
rc: (f = msg.getRc()) && proto.fbproto.RestartController.toObject(includeInstance, f),
rcr: (f = msg.getRcr()) && proto.fbproto.RestartControllerResponse.toObject(includeInstance, f),
oti: (f = msg.getOti()) && proto.fbproto.OtaUpdateInit.toObject(includeInstance, f),
otir: (f = msg.getOtir()) && proto.fbproto.OtaUpdateInitResponse.toObject(includeInstance, f),
otf: (f = msg.getOtf()) && proto.fbproto.OtaUpdateFile.toObject(includeInstance, f),
otfr: (f = msg.getOtfr()) && proto.fbproto.OtaUpdateFileResponse.toObject(includeInstance, f),
otc: (f = msg.getOtc()) && proto.fbproto.OtaUpdateComplete.toObject(includeInstance, f),
otcr: (f = msg.getOtcr()) && proto.fbproto.OtaUpdateCompleteResponse.toObject(includeInstance, f),
rf: (f = msg.getRf()) && proto.fbproto.ReloadFlows.toObject(includeInstance, f),
rfr: (f = msg.getRfr()) && proto.fbproto.ReloadFlowsResponse.toObject(includeInstance, f),
rd: (f = msg.getRd()) && proto.fbproto.RunDevice.toObject(includeInstance, f),
rdr: (f = msg.getRdr()) && proto.fbproto.RunDeviceResponse.toObject(includeInstance, f),
gd: (f = msg.getGd()) && proto.fbproto.GetDevices.toObject(includeInstance, f),
gdr: (f = msg.getGdr()) && proto.fbproto.GetDevicesResponse.toObject(includeInstance, f),
gf: (f = msg.getGf()) && proto.fbproto.GetFlows.toObject(includeInstance, f),
gfr: (f = msg.getGfr()) && proto.fbproto.GetFlowsResponse.toObject(includeInstance, f),
gpc: (f = msg.getGpc()) && proto.fbproto.GetPhCalibration.toObject(includeInstance, f),
gpcr: (f = msg.getGpcr()) && proto.fbproto.GetPhCalibrationResponse.toObject(includeInstance, f),
gdad: (f = msg.getGdad()) && proto.fbproto.GetDeviceAssembliesDevices.toObject(includeInstance, f),
gdadr: (f = msg.getGdadr()) && proto.fbproto.GetDeviceAssembliesDevicesResponse.toObject(includeInstance, f),
gfsr: (f = msg.getGfsr()) && proto.fbproto.GenerateFakeSensorReading.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fbproto.MessageWrapper}
 */
proto.fbproto.MessageWrapper.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fbproto.MessageWrapper;
  return proto.fbproto.MessageWrapper.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fbproto.MessageWrapper} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fbproto.MessageWrapper}
 */
proto.fbproto.MessageWrapper.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.fbproto.MessageWrapper.MessageType} */ (reader.readEnum());
      msg.setMessageType(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setMessageId(value);
      break;
    case 11:
      var value = new proto.fbproto.Response;
      reader.readMessage(value,proto.fbproto.Response.deserializeBinaryFromReader);
      msg.setResponse(value);
      break;
    case 21:
      var value = new proto.fbproto.SensorReading;
      reader.readMessage(value,proto.fbproto.SensorReading.deserializeBinaryFromReader);
      msg.setSr(value);
      break;
    case 22:
      var value = new proto.fbproto.DeviceAttached;
      reader.readMessage(value,proto.fbproto.DeviceAttached.deserializeBinaryFromReader);
      msg.setDa(value);
      break;
    case 23:
      var value = new proto.fbproto.DeviceRemoved;
      reader.readMessage(value,proto.fbproto.DeviceRemoved.deserializeBinaryFromReader);
      msg.setDr(value);
      break;
    case 24:
      var value = new proto.fbproto.SetParam;
      reader.readMessage(value,proto.fbproto.SetParam.deserializeBinaryFromReader);
      msg.setSp(value);
      break;
    case 27:
      var value = new proto.fbproto.CalibratePh;
      reader.readMessage(value,proto.fbproto.CalibratePh.deserializeBinaryFromReader);
      msg.setCp(value);
      break;
    case 28:
      var value = new proto.fbproto.CalibratePhResponse;
      reader.readMessage(value,proto.fbproto.CalibratePhResponse.deserializeBinaryFromReader);
      msg.setCpr(value);
      break;
    case 29:
      var value = new proto.fbproto.RestartController;
      reader.readMessage(value,proto.fbproto.RestartController.deserializeBinaryFromReader);
      msg.setRc(value);
      break;
    case 30:
      var value = new proto.fbproto.RestartControllerResponse;
      reader.readMessage(value,proto.fbproto.RestartControllerResponse.deserializeBinaryFromReader);
      msg.setRcr(value);
      break;
    case 31:
      var value = new proto.fbproto.OtaUpdateInit;
      reader.readMessage(value,proto.fbproto.OtaUpdateInit.deserializeBinaryFromReader);
      msg.setOti(value);
      break;
    case 32:
      var value = new proto.fbproto.OtaUpdateInitResponse;
      reader.readMessage(value,proto.fbproto.OtaUpdateInitResponse.deserializeBinaryFromReader);
      msg.setOtir(value);
      break;
    case 33:
      var value = new proto.fbproto.OtaUpdateFile;
      reader.readMessage(value,proto.fbproto.OtaUpdateFile.deserializeBinaryFromReader);
      msg.setOtf(value);
      break;
    case 34:
      var value = new proto.fbproto.OtaUpdateFileResponse;
      reader.readMessage(value,proto.fbproto.OtaUpdateFileResponse.deserializeBinaryFromReader);
      msg.setOtfr(value);
      break;
    case 35:
      var value = new proto.fbproto.OtaUpdateComplete;
      reader.readMessage(value,proto.fbproto.OtaUpdateComplete.deserializeBinaryFromReader);
      msg.setOtc(value);
      break;
    case 36:
      var value = new proto.fbproto.OtaUpdateCompleteResponse;
      reader.readMessage(value,proto.fbproto.OtaUpdateCompleteResponse.deserializeBinaryFromReader);
      msg.setOtcr(value);
      break;
    case 37:
      var value = new proto.fbproto.ReloadFlows;
      reader.readMessage(value,proto.fbproto.ReloadFlows.deserializeBinaryFromReader);
      msg.setRf(value);
      break;
    case 38:
      var value = new proto.fbproto.ReloadFlowsResponse;
      reader.readMessage(value,proto.fbproto.ReloadFlowsResponse.deserializeBinaryFromReader);
      msg.setRfr(value);
      break;
    case 39:
      var value = new proto.fbproto.RunDevice;
      reader.readMessage(value,proto.fbproto.RunDevice.deserializeBinaryFromReader);
      msg.setRd(value);
      break;
    case 40:
      var value = new proto.fbproto.RunDeviceResponse;
      reader.readMessage(value,proto.fbproto.RunDeviceResponse.deserializeBinaryFromReader);
      msg.setRdr(value);
      break;
    case 101:
      var value = new proto.fbproto.GetDevices;
      reader.readMessage(value,proto.fbproto.GetDevices.deserializeBinaryFromReader);
      msg.setGd(value);
      break;
    case 102:
      var value = new proto.fbproto.GetDevicesResponse;
      reader.readMessage(value,proto.fbproto.GetDevicesResponse.deserializeBinaryFromReader);
      msg.setGdr(value);
      break;
    case 103:
      var value = new proto.fbproto.GetFlows;
      reader.readMessage(value,proto.fbproto.GetFlows.deserializeBinaryFromReader);
      msg.setGf(value);
      break;
    case 104:
      var value = new proto.fbproto.GetFlowsResponse;
      reader.readMessage(value,proto.fbproto.GetFlowsResponse.deserializeBinaryFromReader);
      msg.setGfr(value);
      break;
    case 105:
      var value = new proto.fbproto.GetPhCalibration;
      reader.readMessage(value,proto.fbproto.GetPhCalibration.deserializeBinaryFromReader);
      msg.setGpc(value);
      break;
    case 106:
      var value = new proto.fbproto.GetPhCalibrationResponse;
      reader.readMessage(value,proto.fbproto.GetPhCalibrationResponse.deserializeBinaryFromReader);
      msg.setGpcr(value);
      break;
    case 107:
      var value = new proto.fbproto.GetDeviceAssembliesDevices;
      reader.readMessage(value,proto.fbproto.GetDeviceAssembliesDevices.deserializeBinaryFromReader);
      msg.setGdad(value);
      break;
    case 108:
      var value = new proto.fbproto.GetDeviceAssembliesDevicesResponse;
      reader.readMessage(value,proto.fbproto.GetDeviceAssembliesDevicesResponse.deserializeBinaryFromReader);
      msg.setGdadr(value);
      break;
    case 128:
      var value = new proto.fbproto.GenerateFakeSensorReading;
      reader.readMessage(value,proto.fbproto.GenerateFakeSensorReading.deserializeBinaryFromReader);
      msg.setGfsr(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fbproto.MessageWrapper.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fbproto.MessageWrapper.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fbproto.MessageWrapper} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.MessageWrapper.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {!proto.fbproto.MessageWrapper.MessageType} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getResponse();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.fbproto.Response.serializeBinaryToWriter
    );
  }
  f = message.getSr();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      proto.fbproto.SensorReading.serializeBinaryToWriter
    );
  }
  f = message.getDa();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      proto.fbproto.DeviceAttached.serializeBinaryToWriter
    );
  }
  f = message.getDr();
  if (f != null) {
    writer.writeMessage(
      23,
      f,
      proto.fbproto.DeviceRemoved.serializeBinaryToWriter
    );
  }
  f = message.getSp();
  if (f != null) {
    writer.writeMessage(
      24,
      f,
      proto.fbproto.SetParam.serializeBinaryToWriter
    );
  }
  f = message.getCp();
  if (f != null) {
    writer.writeMessage(
      27,
      f,
      proto.fbproto.CalibratePh.serializeBinaryToWriter
    );
  }
  f = message.getCpr();
  if (f != null) {
    writer.writeMessage(
      28,
      f,
      proto.fbproto.CalibratePhResponse.serializeBinaryToWriter
    );
  }
  f = message.getRc();
  if (f != null) {
    writer.writeMessage(
      29,
      f,
      proto.fbproto.RestartController.serializeBinaryToWriter
    );
  }
  f = message.getRcr();
  if (f != null) {
    writer.writeMessage(
      30,
      f,
      proto.fbproto.RestartControllerResponse.serializeBinaryToWriter
    );
  }
  f = message.getOti();
  if (f != null) {
    writer.writeMessage(
      31,
      f,
      proto.fbproto.OtaUpdateInit.serializeBinaryToWriter
    );
  }
  f = message.getOtir();
  if (f != null) {
    writer.writeMessage(
      32,
      f,
      proto.fbproto.OtaUpdateInitResponse.serializeBinaryToWriter
    );
  }
  f = message.getOtf();
  if (f != null) {
    writer.writeMessage(
      33,
      f,
      proto.fbproto.OtaUpdateFile.serializeBinaryToWriter
    );
  }
  f = message.getOtfr();
  if (f != null) {
    writer.writeMessage(
      34,
      f,
      proto.fbproto.OtaUpdateFileResponse.serializeBinaryToWriter
    );
  }
  f = message.getOtc();
  if (f != null) {
    writer.writeMessage(
      35,
      f,
      proto.fbproto.OtaUpdateComplete.serializeBinaryToWriter
    );
  }
  f = message.getOtcr();
  if (f != null) {
    writer.writeMessage(
      36,
      f,
      proto.fbproto.OtaUpdateCompleteResponse.serializeBinaryToWriter
    );
  }
  f = message.getRf();
  if (f != null) {
    writer.writeMessage(
      37,
      f,
      proto.fbproto.ReloadFlows.serializeBinaryToWriter
    );
  }
  f = message.getRfr();
  if (f != null) {
    writer.writeMessage(
      38,
      f,
      proto.fbproto.ReloadFlowsResponse.serializeBinaryToWriter
    );
  }
  f = message.getRd();
  if (f != null) {
    writer.writeMessage(
      39,
      f,
      proto.fbproto.RunDevice.serializeBinaryToWriter
    );
  }
  f = message.getRdr();
  if (f != null) {
    writer.writeMessage(
      40,
      f,
      proto.fbproto.RunDeviceResponse.serializeBinaryToWriter
    );
  }
  f = message.getGd();
  if (f != null) {
    writer.writeMessage(
      101,
      f,
      proto.fbproto.GetDevices.serializeBinaryToWriter
    );
  }
  f = message.getGdr();
  if (f != null) {
    writer.writeMessage(
      102,
      f,
      proto.fbproto.GetDevicesResponse.serializeBinaryToWriter
    );
  }
  f = message.getGf();
  if (f != null) {
    writer.writeMessage(
      103,
      f,
      proto.fbproto.GetFlows.serializeBinaryToWriter
    );
  }
  f = message.getGfr();
  if (f != null) {
    writer.writeMessage(
      104,
      f,
      proto.fbproto.GetFlowsResponse.serializeBinaryToWriter
    );
  }
  f = message.getGpc();
  if (f != null) {
    writer.writeMessage(
      105,
      f,
      proto.fbproto.GetPhCalibration.serializeBinaryToWriter
    );
  }
  f = message.getGpcr();
  if (f != null) {
    writer.writeMessage(
      106,
      f,
      proto.fbproto.GetPhCalibrationResponse.serializeBinaryToWriter
    );
  }
  f = message.getGdad();
  if (f != null) {
    writer.writeMessage(
      107,
      f,
      proto.fbproto.GetDeviceAssembliesDevices.serializeBinaryToWriter
    );
  }
  f = message.getGdadr();
  if (f != null) {
    writer.writeMessage(
      108,
      f,
      proto.fbproto.GetDeviceAssembliesDevicesResponse.serializeBinaryToWriter
    );
  }
  f = message.getGfsr();
  if (f != null) {
    writer.writeMessage(
      128,
      f,
      proto.fbproto.GenerateFakeSensorReading.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.fbproto.MessageWrapper.MessageType = {
  MESSAGE_NONE: 0,
  MESSAGE_RESPONSE: 11,
  MESSAGE_SENSOR_READING: 21,
  MESSAGE_DEVICE_ATTACHED: 22,
  MESSAGE_DEVICE_REMOVED: 23,
  MESSAGE_SET_PARAM: 24,
  MESSAGE_ADD_TRIGGER: 25,
  MESSAGE_REMOVE_TRIGGER: 26,
  MESSAGE_CALIBRATE_PH: 27,
  MESSAGE_CALIBRATE_PH_RESPONSE: 28,
  MESSAGE_RUN_DEVICE: 39,
  MESSAGE_RUN_DEVICE_RESPONSE: 40,
  MESSAGE_GENERATE_READING: 128
};

/**
 * optional MessageType message_type = 1;
 * @return {!proto.fbproto.MessageWrapper.MessageType}
 */
proto.fbproto.MessageWrapper.prototype.getMessageType = function() {
  return /** @type {!proto.fbproto.MessageWrapper.MessageType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.fbproto.MessageWrapper.MessageType} value
 * @return {!proto.fbproto.MessageWrapper} returns this
 */
proto.fbproto.MessageWrapper.prototype.setMessageType = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.MessageWrapper} returns this
 */
proto.fbproto.MessageWrapper.prototype.clearMessageType = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.MessageWrapper.prototype.hasMessageType = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional uint64 message_id = 2;
 * @return {number}
 */
proto.fbproto.MessageWrapper.prototype.getMessageId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.fbproto.MessageWrapper} returns this
 */
proto.fbproto.MessageWrapper.prototype.setMessageId = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.MessageWrapper} returns this
 */
proto.fbproto.MessageWrapper.prototype.clearMessageId = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.MessageWrapper.prototype.hasMessageId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Response response = 11;
 * @return {?proto.fbproto.Response}
 */
proto.fbproto.MessageWrapper.prototype.getResponse = function() {
  return /** @type{?proto.fbproto.Response} */ (
    jspb.Message.getWrapperField(this, proto.fbproto.Response, 11));
};


/**
 * @param {?proto.fbproto.Response|undefined} value
 * @return {!proto.fbproto.MessageWrapper} returns this
*/
proto.fbproto.MessageWrapper.prototype.setResponse = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fbproto.MessageWrapper} returns this
 */
proto.fbproto.MessageWrapper.prototype.clearResponse = function() {
  return this.setResponse(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.MessageWrapper.prototype.hasResponse = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional SensorReading sr = 21;
 * @return {?proto.fbproto.SensorReading}
 */
proto.fbproto.MessageWrapper.prototype.getSr = function() {
  return /** @type{?proto.fbproto.SensorReading} */ (
    jspb.Message.getWrapperField(this, proto.fbproto.SensorReading, 21));
};


/**
 * @param {?proto.fbproto.SensorReading|undefined} value
 * @return {!proto.fbproto.MessageWrapper} returns this
*/
proto.fbproto.MessageWrapper.prototype.setSr = function(value) {
  return jspb.Message.setOneofWrapperField(this, 21, proto.fbproto.MessageWrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fbproto.MessageWrapper} returns this
 */
proto.fbproto.MessageWrapper.prototype.clearSr = function() {
  return this.setSr(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.MessageWrapper.prototype.hasSr = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional DeviceAttached da = 22;
 * @return {?proto.fbproto.DeviceAttached}
 */
proto.fbproto.MessageWrapper.prototype.getDa = function() {
  return /** @type{?proto.fbproto.DeviceAttached} */ (
    jspb.Message.getWrapperField(this, proto.fbproto.DeviceAttached, 22));
};


/**
 * @param {?proto.fbproto.DeviceAttached|undefined} value
 * @return {!proto.fbproto.MessageWrapper} returns this
*/
proto.fbproto.MessageWrapper.prototype.setDa = function(value) {
  return jspb.Message.setOneofWrapperField(this, 22, proto.fbproto.MessageWrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fbproto.MessageWrapper} returns this
 */
proto.fbproto.MessageWrapper.prototype.clearDa = function() {
  return this.setDa(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.MessageWrapper.prototype.hasDa = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional DeviceRemoved dr = 23;
 * @return {?proto.fbproto.DeviceRemoved}
 */
proto.fbproto.MessageWrapper.prototype.getDr = function() {
  return /** @type{?proto.fbproto.DeviceRemoved} */ (
    jspb.Message.getWrapperField(this, proto.fbproto.DeviceRemoved, 23));
};


/**
 * @param {?proto.fbproto.DeviceRemoved|undefined} value
 * @return {!proto.fbproto.MessageWrapper} returns this
*/
proto.fbproto.MessageWrapper.prototype.setDr = function(value) {
  return jspb.Message.setOneofWrapperField(this, 23, proto.fbproto.MessageWrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fbproto.MessageWrapper} returns this
 */
proto.fbproto.MessageWrapper.prototype.clearDr = function() {
  return this.setDr(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.MessageWrapper.prototype.hasDr = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional SetParam sp = 24;
 * @return {?proto.fbproto.SetParam}
 */
proto.fbproto.MessageWrapper.prototype.getSp = function() {
  return /** @type{?proto.fbproto.SetParam} */ (
    jspb.Message.getWrapperField(this, proto.fbproto.SetParam, 24));
};


/**
 * @param {?proto.fbproto.SetParam|undefined} value
 * @return {!proto.fbproto.MessageWrapper} returns this
*/
proto.fbproto.MessageWrapper.prototype.setSp = function(value) {
  return jspb.Message.setOneofWrapperField(this, 24, proto.fbproto.MessageWrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fbproto.MessageWrapper} returns this
 */
proto.fbproto.MessageWrapper.prototype.clearSp = function() {
  return this.setSp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.MessageWrapper.prototype.hasSp = function() {
  return jspb.Message.getField(this, 24) != null;
};


/**
 * optional CalibratePh cp = 27;
 * @return {?proto.fbproto.CalibratePh}
 */
proto.fbproto.MessageWrapper.prototype.getCp = function() {
  return /** @type{?proto.fbproto.CalibratePh} */ (
    jspb.Message.getWrapperField(this, proto.fbproto.CalibratePh, 27));
};


/**
 * @param {?proto.fbproto.CalibratePh|undefined} value
 * @return {!proto.fbproto.MessageWrapper} returns this
*/
proto.fbproto.MessageWrapper.prototype.setCp = function(value) {
  return jspb.Message.setOneofWrapperField(this, 27, proto.fbproto.MessageWrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fbproto.MessageWrapper} returns this
 */
proto.fbproto.MessageWrapper.prototype.clearCp = function() {
  return this.setCp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.MessageWrapper.prototype.hasCp = function() {
  return jspb.Message.getField(this, 27) != null;
};


/**
 * optional CalibratePhResponse cpr = 28;
 * @return {?proto.fbproto.CalibratePhResponse}
 */
proto.fbproto.MessageWrapper.prototype.getCpr = function() {
  return /** @type{?proto.fbproto.CalibratePhResponse} */ (
    jspb.Message.getWrapperField(this, proto.fbproto.CalibratePhResponse, 28));
};


/**
 * @param {?proto.fbproto.CalibratePhResponse|undefined} value
 * @return {!proto.fbproto.MessageWrapper} returns this
*/
proto.fbproto.MessageWrapper.prototype.setCpr = function(value) {
  return jspb.Message.setOneofWrapperField(this, 28, proto.fbproto.MessageWrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fbproto.MessageWrapper} returns this
 */
proto.fbproto.MessageWrapper.prototype.clearCpr = function() {
  return this.setCpr(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.MessageWrapper.prototype.hasCpr = function() {
  return jspb.Message.getField(this, 28) != null;
};


/**
 * optional RestartController rc = 29;
 * @return {?proto.fbproto.RestartController}
 */
proto.fbproto.MessageWrapper.prototype.getRc = function() {
  return /** @type{?proto.fbproto.RestartController} */ (
    jspb.Message.getWrapperField(this, proto.fbproto.RestartController, 29));
};


/**
 * @param {?proto.fbproto.RestartController|undefined} value
 * @return {!proto.fbproto.MessageWrapper} returns this
*/
proto.fbproto.MessageWrapper.prototype.setRc = function(value) {
  return jspb.Message.setOneofWrapperField(this, 29, proto.fbproto.MessageWrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fbproto.MessageWrapper} returns this
 */
proto.fbproto.MessageWrapper.prototype.clearRc = function() {
  return this.setRc(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.MessageWrapper.prototype.hasRc = function() {
  return jspb.Message.getField(this, 29) != null;
};


/**
 * optional RestartControllerResponse rcr = 30;
 * @return {?proto.fbproto.RestartControllerResponse}
 */
proto.fbproto.MessageWrapper.prototype.getRcr = function() {
  return /** @type{?proto.fbproto.RestartControllerResponse} */ (
    jspb.Message.getWrapperField(this, proto.fbproto.RestartControllerResponse, 30));
};


/**
 * @param {?proto.fbproto.RestartControllerResponse|undefined} value
 * @return {!proto.fbproto.MessageWrapper} returns this
*/
proto.fbproto.MessageWrapper.prototype.setRcr = function(value) {
  return jspb.Message.setOneofWrapperField(this, 30, proto.fbproto.MessageWrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fbproto.MessageWrapper} returns this
 */
proto.fbproto.MessageWrapper.prototype.clearRcr = function() {
  return this.setRcr(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.MessageWrapper.prototype.hasRcr = function() {
  return jspb.Message.getField(this, 30) != null;
};


/**
 * optional OtaUpdateInit oti = 31;
 * @return {?proto.fbproto.OtaUpdateInit}
 */
proto.fbproto.MessageWrapper.prototype.getOti = function() {
  return /** @type{?proto.fbproto.OtaUpdateInit} */ (
    jspb.Message.getWrapperField(this, proto.fbproto.OtaUpdateInit, 31));
};


/**
 * @param {?proto.fbproto.OtaUpdateInit|undefined} value
 * @return {!proto.fbproto.MessageWrapper} returns this
*/
proto.fbproto.MessageWrapper.prototype.setOti = function(value) {
  return jspb.Message.setOneofWrapperField(this, 31, proto.fbproto.MessageWrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fbproto.MessageWrapper} returns this
 */
proto.fbproto.MessageWrapper.prototype.clearOti = function() {
  return this.setOti(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.MessageWrapper.prototype.hasOti = function() {
  return jspb.Message.getField(this, 31) != null;
};


/**
 * optional OtaUpdateInitResponse otir = 32;
 * @return {?proto.fbproto.OtaUpdateInitResponse}
 */
proto.fbproto.MessageWrapper.prototype.getOtir = function() {
  return /** @type{?proto.fbproto.OtaUpdateInitResponse} */ (
    jspb.Message.getWrapperField(this, proto.fbproto.OtaUpdateInitResponse, 32));
};


/**
 * @param {?proto.fbproto.OtaUpdateInitResponse|undefined} value
 * @return {!proto.fbproto.MessageWrapper} returns this
*/
proto.fbproto.MessageWrapper.prototype.setOtir = function(value) {
  return jspb.Message.setOneofWrapperField(this, 32, proto.fbproto.MessageWrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fbproto.MessageWrapper} returns this
 */
proto.fbproto.MessageWrapper.prototype.clearOtir = function() {
  return this.setOtir(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.MessageWrapper.prototype.hasOtir = function() {
  return jspb.Message.getField(this, 32) != null;
};


/**
 * optional OtaUpdateFile otf = 33;
 * @return {?proto.fbproto.OtaUpdateFile}
 */
proto.fbproto.MessageWrapper.prototype.getOtf = function() {
  return /** @type{?proto.fbproto.OtaUpdateFile} */ (
    jspb.Message.getWrapperField(this, proto.fbproto.OtaUpdateFile, 33));
};


/**
 * @param {?proto.fbproto.OtaUpdateFile|undefined} value
 * @return {!proto.fbproto.MessageWrapper} returns this
*/
proto.fbproto.MessageWrapper.prototype.setOtf = function(value) {
  return jspb.Message.setOneofWrapperField(this, 33, proto.fbproto.MessageWrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fbproto.MessageWrapper} returns this
 */
proto.fbproto.MessageWrapper.prototype.clearOtf = function() {
  return this.setOtf(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.MessageWrapper.prototype.hasOtf = function() {
  return jspb.Message.getField(this, 33) != null;
};


/**
 * optional OtaUpdateFileResponse otfr = 34;
 * @return {?proto.fbproto.OtaUpdateFileResponse}
 */
proto.fbproto.MessageWrapper.prototype.getOtfr = function() {
  return /** @type{?proto.fbproto.OtaUpdateFileResponse} */ (
    jspb.Message.getWrapperField(this, proto.fbproto.OtaUpdateFileResponse, 34));
};


/**
 * @param {?proto.fbproto.OtaUpdateFileResponse|undefined} value
 * @return {!proto.fbproto.MessageWrapper} returns this
*/
proto.fbproto.MessageWrapper.prototype.setOtfr = function(value) {
  return jspb.Message.setOneofWrapperField(this, 34, proto.fbproto.MessageWrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fbproto.MessageWrapper} returns this
 */
proto.fbproto.MessageWrapper.prototype.clearOtfr = function() {
  return this.setOtfr(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.MessageWrapper.prototype.hasOtfr = function() {
  return jspb.Message.getField(this, 34) != null;
};


/**
 * optional OtaUpdateComplete otc = 35;
 * @return {?proto.fbproto.OtaUpdateComplete}
 */
proto.fbproto.MessageWrapper.prototype.getOtc = function() {
  return /** @type{?proto.fbproto.OtaUpdateComplete} */ (
    jspb.Message.getWrapperField(this, proto.fbproto.OtaUpdateComplete, 35));
};


/**
 * @param {?proto.fbproto.OtaUpdateComplete|undefined} value
 * @return {!proto.fbproto.MessageWrapper} returns this
*/
proto.fbproto.MessageWrapper.prototype.setOtc = function(value) {
  return jspb.Message.setOneofWrapperField(this, 35, proto.fbproto.MessageWrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fbproto.MessageWrapper} returns this
 */
proto.fbproto.MessageWrapper.prototype.clearOtc = function() {
  return this.setOtc(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.MessageWrapper.prototype.hasOtc = function() {
  return jspb.Message.getField(this, 35) != null;
};


/**
 * optional OtaUpdateCompleteResponse otcr = 36;
 * @return {?proto.fbproto.OtaUpdateCompleteResponse}
 */
proto.fbproto.MessageWrapper.prototype.getOtcr = function() {
  return /** @type{?proto.fbproto.OtaUpdateCompleteResponse} */ (
    jspb.Message.getWrapperField(this, proto.fbproto.OtaUpdateCompleteResponse, 36));
};


/**
 * @param {?proto.fbproto.OtaUpdateCompleteResponse|undefined} value
 * @return {!proto.fbproto.MessageWrapper} returns this
*/
proto.fbproto.MessageWrapper.prototype.setOtcr = function(value) {
  return jspb.Message.setOneofWrapperField(this, 36, proto.fbproto.MessageWrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fbproto.MessageWrapper} returns this
 */
proto.fbproto.MessageWrapper.prototype.clearOtcr = function() {
  return this.setOtcr(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.MessageWrapper.prototype.hasOtcr = function() {
  return jspb.Message.getField(this, 36) != null;
};


/**
 * optional ReloadFlows rf = 37;
 * @return {?proto.fbproto.ReloadFlows}
 */
proto.fbproto.MessageWrapper.prototype.getRf = function() {
  return /** @type{?proto.fbproto.ReloadFlows} */ (
    jspb.Message.getWrapperField(this, proto.fbproto.ReloadFlows, 37));
};


/**
 * @param {?proto.fbproto.ReloadFlows|undefined} value
 * @return {!proto.fbproto.MessageWrapper} returns this
*/
proto.fbproto.MessageWrapper.prototype.setRf = function(value) {
  return jspb.Message.setOneofWrapperField(this, 37, proto.fbproto.MessageWrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fbproto.MessageWrapper} returns this
 */
proto.fbproto.MessageWrapper.prototype.clearRf = function() {
  return this.setRf(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.MessageWrapper.prototype.hasRf = function() {
  return jspb.Message.getField(this, 37) != null;
};


/**
 * optional ReloadFlowsResponse rfr = 38;
 * @return {?proto.fbproto.ReloadFlowsResponse}
 */
proto.fbproto.MessageWrapper.prototype.getRfr = function() {
  return /** @type{?proto.fbproto.ReloadFlowsResponse} */ (
    jspb.Message.getWrapperField(this, proto.fbproto.ReloadFlowsResponse, 38));
};


/**
 * @param {?proto.fbproto.ReloadFlowsResponse|undefined} value
 * @return {!proto.fbproto.MessageWrapper} returns this
*/
proto.fbproto.MessageWrapper.prototype.setRfr = function(value) {
  return jspb.Message.setOneofWrapperField(this, 38, proto.fbproto.MessageWrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fbproto.MessageWrapper} returns this
 */
proto.fbproto.MessageWrapper.prototype.clearRfr = function() {
  return this.setRfr(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.MessageWrapper.prototype.hasRfr = function() {
  return jspb.Message.getField(this, 38) != null;
};


/**
 * optional RunDevice rd = 39;
 * @return {?proto.fbproto.RunDevice}
 */
proto.fbproto.MessageWrapper.prototype.getRd = function() {
  return /** @type{?proto.fbproto.RunDevice} */ (
    jspb.Message.getWrapperField(this, proto.fbproto.RunDevice, 39));
};


/**
 * @param {?proto.fbproto.RunDevice|undefined} value
 * @return {!proto.fbproto.MessageWrapper} returns this
*/
proto.fbproto.MessageWrapper.prototype.setRd = function(value) {
  return jspb.Message.setOneofWrapperField(this, 39, proto.fbproto.MessageWrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fbproto.MessageWrapper} returns this
 */
proto.fbproto.MessageWrapper.prototype.clearRd = function() {
  return this.setRd(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.MessageWrapper.prototype.hasRd = function() {
  return jspb.Message.getField(this, 39) != null;
};


/**
 * optional RunDeviceResponse rdr = 40;
 * @return {?proto.fbproto.RunDeviceResponse}
 */
proto.fbproto.MessageWrapper.prototype.getRdr = function() {
  return /** @type{?proto.fbproto.RunDeviceResponse} */ (
    jspb.Message.getWrapperField(this, proto.fbproto.RunDeviceResponse, 40));
};


/**
 * @param {?proto.fbproto.RunDeviceResponse|undefined} value
 * @return {!proto.fbproto.MessageWrapper} returns this
*/
proto.fbproto.MessageWrapper.prototype.setRdr = function(value) {
  return jspb.Message.setOneofWrapperField(this, 40, proto.fbproto.MessageWrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fbproto.MessageWrapper} returns this
 */
proto.fbproto.MessageWrapper.prototype.clearRdr = function() {
  return this.setRdr(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.MessageWrapper.prototype.hasRdr = function() {
  return jspb.Message.getField(this, 40) != null;
};


/**
 * optional GetDevices gd = 101;
 * @return {?proto.fbproto.GetDevices}
 */
proto.fbproto.MessageWrapper.prototype.getGd = function() {
  return /** @type{?proto.fbproto.GetDevices} */ (
    jspb.Message.getWrapperField(this, proto.fbproto.GetDevices, 101));
};


/**
 * @param {?proto.fbproto.GetDevices|undefined} value
 * @return {!proto.fbproto.MessageWrapper} returns this
*/
proto.fbproto.MessageWrapper.prototype.setGd = function(value) {
  return jspb.Message.setOneofWrapperField(this, 101, proto.fbproto.MessageWrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fbproto.MessageWrapper} returns this
 */
proto.fbproto.MessageWrapper.prototype.clearGd = function() {
  return this.setGd(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.MessageWrapper.prototype.hasGd = function() {
  return jspb.Message.getField(this, 101) != null;
};


/**
 * optional GetDevicesResponse gdr = 102;
 * @return {?proto.fbproto.GetDevicesResponse}
 */
proto.fbproto.MessageWrapper.prototype.getGdr = function() {
  return /** @type{?proto.fbproto.GetDevicesResponse} */ (
    jspb.Message.getWrapperField(this, proto.fbproto.GetDevicesResponse, 102));
};


/**
 * @param {?proto.fbproto.GetDevicesResponse|undefined} value
 * @return {!proto.fbproto.MessageWrapper} returns this
*/
proto.fbproto.MessageWrapper.prototype.setGdr = function(value) {
  return jspb.Message.setOneofWrapperField(this, 102, proto.fbproto.MessageWrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fbproto.MessageWrapper} returns this
 */
proto.fbproto.MessageWrapper.prototype.clearGdr = function() {
  return this.setGdr(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.MessageWrapper.prototype.hasGdr = function() {
  return jspb.Message.getField(this, 102) != null;
};


/**
 * optional GetFlows gf = 103;
 * @return {?proto.fbproto.GetFlows}
 */
proto.fbproto.MessageWrapper.prototype.getGf = function() {
  return /** @type{?proto.fbproto.GetFlows} */ (
    jspb.Message.getWrapperField(this, proto.fbproto.GetFlows, 103));
};


/**
 * @param {?proto.fbproto.GetFlows|undefined} value
 * @return {!proto.fbproto.MessageWrapper} returns this
*/
proto.fbproto.MessageWrapper.prototype.setGf = function(value) {
  return jspb.Message.setOneofWrapperField(this, 103, proto.fbproto.MessageWrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fbproto.MessageWrapper} returns this
 */
proto.fbproto.MessageWrapper.prototype.clearGf = function() {
  return this.setGf(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.MessageWrapper.prototype.hasGf = function() {
  return jspb.Message.getField(this, 103) != null;
};


/**
 * optional GetFlowsResponse gfr = 104;
 * @return {?proto.fbproto.GetFlowsResponse}
 */
proto.fbproto.MessageWrapper.prototype.getGfr = function() {
  return /** @type{?proto.fbproto.GetFlowsResponse} */ (
    jspb.Message.getWrapperField(this, proto.fbproto.GetFlowsResponse, 104));
};


/**
 * @param {?proto.fbproto.GetFlowsResponse|undefined} value
 * @return {!proto.fbproto.MessageWrapper} returns this
*/
proto.fbproto.MessageWrapper.prototype.setGfr = function(value) {
  return jspb.Message.setOneofWrapperField(this, 104, proto.fbproto.MessageWrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fbproto.MessageWrapper} returns this
 */
proto.fbproto.MessageWrapper.prototype.clearGfr = function() {
  return this.setGfr(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.MessageWrapper.prototype.hasGfr = function() {
  return jspb.Message.getField(this, 104) != null;
};


/**
 * optional GetPhCalibration gpc = 105;
 * @return {?proto.fbproto.GetPhCalibration}
 */
proto.fbproto.MessageWrapper.prototype.getGpc = function() {
  return /** @type{?proto.fbproto.GetPhCalibration} */ (
    jspb.Message.getWrapperField(this, proto.fbproto.GetPhCalibration, 105));
};


/**
 * @param {?proto.fbproto.GetPhCalibration|undefined} value
 * @return {!proto.fbproto.MessageWrapper} returns this
*/
proto.fbproto.MessageWrapper.prototype.setGpc = function(value) {
  return jspb.Message.setOneofWrapperField(this, 105, proto.fbproto.MessageWrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fbproto.MessageWrapper} returns this
 */
proto.fbproto.MessageWrapper.prototype.clearGpc = function() {
  return this.setGpc(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.MessageWrapper.prototype.hasGpc = function() {
  return jspb.Message.getField(this, 105) != null;
};


/**
 * optional GetPhCalibrationResponse gpcr = 106;
 * @return {?proto.fbproto.GetPhCalibrationResponse}
 */
proto.fbproto.MessageWrapper.prototype.getGpcr = function() {
  return /** @type{?proto.fbproto.GetPhCalibrationResponse} */ (
    jspb.Message.getWrapperField(this, proto.fbproto.GetPhCalibrationResponse, 106));
};


/**
 * @param {?proto.fbproto.GetPhCalibrationResponse|undefined} value
 * @return {!proto.fbproto.MessageWrapper} returns this
*/
proto.fbproto.MessageWrapper.prototype.setGpcr = function(value) {
  return jspb.Message.setOneofWrapperField(this, 106, proto.fbproto.MessageWrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fbproto.MessageWrapper} returns this
 */
proto.fbproto.MessageWrapper.prototype.clearGpcr = function() {
  return this.setGpcr(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.MessageWrapper.prototype.hasGpcr = function() {
  return jspb.Message.getField(this, 106) != null;
};


/**
 * optional GetDeviceAssembliesDevices gdad = 107;
 * @return {?proto.fbproto.GetDeviceAssembliesDevices}
 */
proto.fbproto.MessageWrapper.prototype.getGdad = function() {
  return /** @type{?proto.fbproto.GetDeviceAssembliesDevices} */ (
    jspb.Message.getWrapperField(this, proto.fbproto.GetDeviceAssembliesDevices, 107));
};


/**
 * @param {?proto.fbproto.GetDeviceAssembliesDevices|undefined} value
 * @return {!proto.fbproto.MessageWrapper} returns this
*/
proto.fbproto.MessageWrapper.prototype.setGdad = function(value) {
  return jspb.Message.setOneofWrapperField(this, 107, proto.fbproto.MessageWrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fbproto.MessageWrapper} returns this
 */
proto.fbproto.MessageWrapper.prototype.clearGdad = function() {
  return this.setGdad(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.MessageWrapper.prototype.hasGdad = function() {
  return jspb.Message.getField(this, 107) != null;
};


/**
 * optional GetDeviceAssembliesDevicesResponse gdadr = 108;
 * @return {?proto.fbproto.GetDeviceAssembliesDevicesResponse}
 */
proto.fbproto.MessageWrapper.prototype.getGdadr = function() {
  return /** @type{?proto.fbproto.GetDeviceAssembliesDevicesResponse} */ (
    jspb.Message.getWrapperField(this, proto.fbproto.GetDeviceAssembliesDevicesResponse, 108));
};


/**
 * @param {?proto.fbproto.GetDeviceAssembliesDevicesResponse|undefined} value
 * @return {!proto.fbproto.MessageWrapper} returns this
*/
proto.fbproto.MessageWrapper.prototype.setGdadr = function(value) {
  return jspb.Message.setOneofWrapperField(this, 108, proto.fbproto.MessageWrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fbproto.MessageWrapper} returns this
 */
proto.fbproto.MessageWrapper.prototype.clearGdadr = function() {
  return this.setGdadr(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.MessageWrapper.prototype.hasGdadr = function() {
  return jspb.Message.getField(this, 108) != null;
};


/**
 * optional GenerateFakeSensorReading gfsr = 128;
 * @return {?proto.fbproto.GenerateFakeSensorReading}
 */
proto.fbproto.MessageWrapper.prototype.getGfsr = function() {
  return /** @type{?proto.fbproto.GenerateFakeSensorReading} */ (
    jspb.Message.getWrapperField(this, proto.fbproto.GenerateFakeSensorReading, 128));
};


/**
 * @param {?proto.fbproto.GenerateFakeSensorReading|undefined} value
 * @return {!proto.fbproto.MessageWrapper} returns this
*/
proto.fbproto.MessageWrapper.prototype.setGfsr = function(value) {
  return jspb.Message.setOneofWrapperField(this, 128, proto.fbproto.MessageWrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fbproto.MessageWrapper} returns this
 */
proto.fbproto.MessageWrapper.prototype.clearGfsr = function() {
  return this.setGfsr(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.MessageWrapper.prototype.hasGfsr = function() {
  return jspb.Message.getField(this, 128) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fbproto.Response.prototype.toObject = function(opt_includeInstance) {
  return proto.fbproto.Response.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fbproto.Response} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.Response.toObject = function(includeInstance, msg) {
  var f, obj = {
errorCode: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
errorMessage: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fbproto.Response}
 */
proto.fbproto.Response.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fbproto.Response;
  return proto.fbproto.Response.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fbproto.Response} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fbproto.Response}
 */
proto.fbproto.Response.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.fbproto.Error} */ (reader.readEnum());
      msg.setErrorCode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setErrorMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fbproto.Response.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fbproto.Response.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fbproto.Response} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.Response.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {!proto.fbproto.Error} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional Error error_code = 1;
 * @return {!proto.fbproto.Error}
 */
proto.fbproto.Response.prototype.getErrorCode = function() {
  return /** @type {!proto.fbproto.Error} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.fbproto.Error} value
 * @return {!proto.fbproto.Response} returns this
 */
proto.fbproto.Response.prototype.setErrorCode = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.Response} returns this
 */
proto.fbproto.Response.prototype.clearErrorCode = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.Response.prototype.hasErrorCode = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string error_message = 2;
 * @return {string}
 */
proto.fbproto.Response.prototype.getErrorMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fbproto.Response} returns this
 */
proto.fbproto.Response.prototype.setErrorMessage = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.Response} returns this
 */
proto.fbproto.Response.prototype.clearErrorMessage = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.Response.prototype.hasErrorMessage = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.fbproto.SensorReading.oneofGroups_ = [[11,12,13],[51,52,53]];

/**
 * @enum {number}
 */
proto.fbproto.SensorReading.ReadingCase = {
  READING_NOT_SET: 0,
  VALUE_F: 11,
  VALUE_I32: 12,
  VALUE_B: 13
};

/**
 * @return {proto.fbproto.SensorReading.ReadingCase}
 */
proto.fbproto.SensorReading.prototype.getReadingCase = function() {
  return /** @type {proto.fbproto.SensorReading.ReadingCase} */(jspb.Message.computeOneofCase(this, proto.fbproto.SensorReading.oneofGroups_[0]));
};

/**
 * @enum {number}
 */
proto.fbproto.SensorReading.RawReadingCase = {
  RAW_READING_NOT_SET: 0,
  RAW_VALUE_F: 51,
  RAW_VALUE_I32: 52,
  RAW_VALUE_B: 53
};

/**
 * @return {proto.fbproto.SensorReading.RawReadingCase}
 */
proto.fbproto.SensorReading.prototype.getRawReadingCase = function() {
  return /** @type {proto.fbproto.SensorReading.RawReadingCase} */(jspb.Message.computeOneofCase(this, proto.fbproto.SensorReading.oneofGroups_[1]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fbproto.SensorReading.prototype.toObject = function(opt_includeInstance) {
  return proto.fbproto.SensorReading.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fbproto.SensorReading} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.SensorReading.toObject = function(includeInstance, msg) {
  var f, obj = {
readingType: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
controllerId: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
deviceId: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
date: (f = msg.getDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
valueF: (f = jspb.Message.getOptionalFloatingPointField(msg, 11)) == null ? undefined : f,
valueI32: (f = jspb.Message.getField(msg, 12)) == null ? undefined : f,
valueB: (f = jspb.Message.getBooleanField(msg, 13)) == null ? undefined : f,
rawValueF: (f = jspb.Message.getOptionalFloatingPointField(msg, 51)) == null ? undefined : f,
rawValueI32: (f = jspb.Message.getField(msg, 52)) == null ? undefined : f,
rawValueB: (f = jspb.Message.getBooleanField(msg, 53)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fbproto.SensorReading}
 */
proto.fbproto.SensorReading.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fbproto.SensorReading;
  return proto.fbproto.SensorReading.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fbproto.SensorReading} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fbproto.SensorReading}
 */
proto.fbproto.SensorReading.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.fbproto.ReadingType} */ (reader.readEnum());
      msg.setReadingType(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setControllerId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDeviceId(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDate(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setValueF(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setValueI32(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setValueB(value);
      break;
    case 51:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setRawValueF(value);
      break;
    case 52:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRawValueI32(value);
      break;
    case 53:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRawValueB(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fbproto.SensorReading.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fbproto.SensorReading.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fbproto.SensorReading} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.SensorReading.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {!proto.fbproto.ReadingType} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getDate();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 11));
  if (f != null) {
    writer.writeFloat(
      11,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 12));
  if (f != null) {
    writer.writeInt32(
      12,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 13));
  if (f != null) {
    writer.writeBool(
      13,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 51));
  if (f != null) {
    writer.writeFloat(
      51,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 52));
  if (f != null) {
    writer.writeInt32(
      52,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 53));
  if (f != null) {
    writer.writeBool(
      53,
      f
    );
  }
};


/**
 * optional ReadingType reading_type = 1;
 * @return {!proto.fbproto.ReadingType}
 */
proto.fbproto.SensorReading.prototype.getReadingType = function() {
  return /** @type {!proto.fbproto.ReadingType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.fbproto.ReadingType} value
 * @return {!proto.fbproto.SensorReading} returns this
 */
proto.fbproto.SensorReading.prototype.setReadingType = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.SensorReading} returns this
 */
proto.fbproto.SensorReading.prototype.clearReadingType = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.SensorReading.prototype.hasReadingType = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 controller_id = 2;
 * @return {number}
 */
proto.fbproto.SensorReading.prototype.getControllerId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.fbproto.SensorReading} returns this
 */
proto.fbproto.SensorReading.prototype.setControllerId = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.SensorReading} returns this
 */
proto.fbproto.SensorReading.prototype.clearControllerId = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.SensorReading.prototype.hasControllerId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 device_id = 3;
 * @return {number}
 */
proto.fbproto.SensorReading.prototype.getDeviceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.fbproto.SensorReading} returns this
 */
proto.fbproto.SensorReading.prototype.setDeviceId = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.SensorReading} returns this
 */
proto.fbproto.SensorReading.prototype.clearDeviceId = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.SensorReading.prototype.hasDeviceId = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.Timestamp date = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fbproto.SensorReading.prototype.getDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fbproto.SensorReading} returns this
*/
proto.fbproto.SensorReading.prototype.setDate = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fbproto.SensorReading} returns this
 */
proto.fbproto.SensorReading.prototype.clearDate = function() {
  return this.setDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.SensorReading.prototype.hasDate = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional float value_f = 11;
 * @return {number}
 */
proto.fbproto.SensorReading.prototype.getValueF = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 11, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.fbproto.SensorReading} returns this
 */
proto.fbproto.SensorReading.prototype.setValueF = function(value) {
  return jspb.Message.setOneofField(this, 11, proto.fbproto.SensorReading.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.SensorReading} returns this
 */
proto.fbproto.SensorReading.prototype.clearValueF = function() {
  return jspb.Message.setOneofField(this, 11, proto.fbproto.SensorReading.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.SensorReading.prototype.hasValueF = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional int32 value_i32 = 12;
 * @return {number}
 */
proto.fbproto.SensorReading.prototype.getValueI32 = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.fbproto.SensorReading} returns this
 */
proto.fbproto.SensorReading.prototype.setValueI32 = function(value) {
  return jspb.Message.setOneofField(this, 12, proto.fbproto.SensorReading.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.SensorReading} returns this
 */
proto.fbproto.SensorReading.prototype.clearValueI32 = function() {
  return jspb.Message.setOneofField(this, 12, proto.fbproto.SensorReading.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.SensorReading.prototype.hasValueI32 = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional bool value_b = 13;
 * @return {boolean}
 */
proto.fbproto.SensorReading.prototype.getValueB = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fbproto.SensorReading} returns this
 */
proto.fbproto.SensorReading.prototype.setValueB = function(value) {
  return jspb.Message.setOneofField(this, 13, proto.fbproto.SensorReading.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.SensorReading} returns this
 */
proto.fbproto.SensorReading.prototype.clearValueB = function() {
  return jspb.Message.setOneofField(this, 13, proto.fbproto.SensorReading.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.SensorReading.prototype.hasValueB = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional float raw_value_f = 51;
 * @return {number}
 */
proto.fbproto.SensorReading.prototype.getRawValueF = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 51, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.fbproto.SensorReading} returns this
 */
proto.fbproto.SensorReading.prototype.setRawValueF = function(value) {
  return jspb.Message.setOneofField(this, 51, proto.fbproto.SensorReading.oneofGroups_[1], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.SensorReading} returns this
 */
proto.fbproto.SensorReading.prototype.clearRawValueF = function() {
  return jspb.Message.setOneofField(this, 51, proto.fbproto.SensorReading.oneofGroups_[1], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.SensorReading.prototype.hasRawValueF = function() {
  return jspb.Message.getField(this, 51) != null;
};


/**
 * optional int32 raw_value_i32 = 52;
 * @return {number}
 */
proto.fbproto.SensorReading.prototype.getRawValueI32 = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 52, 0));
};


/**
 * @param {number} value
 * @return {!proto.fbproto.SensorReading} returns this
 */
proto.fbproto.SensorReading.prototype.setRawValueI32 = function(value) {
  return jspb.Message.setOneofField(this, 52, proto.fbproto.SensorReading.oneofGroups_[1], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.SensorReading} returns this
 */
proto.fbproto.SensorReading.prototype.clearRawValueI32 = function() {
  return jspb.Message.setOneofField(this, 52, proto.fbproto.SensorReading.oneofGroups_[1], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.SensorReading.prototype.hasRawValueI32 = function() {
  return jspb.Message.getField(this, 52) != null;
};


/**
 * optional bool raw_value_b = 53;
 * @return {boolean}
 */
proto.fbproto.SensorReading.prototype.getRawValueB = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 53, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fbproto.SensorReading} returns this
 */
proto.fbproto.SensorReading.prototype.setRawValueB = function(value) {
  return jspb.Message.setOneofField(this, 53, proto.fbproto.SensorReading.oneofGroups_[1], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.SensorReading} returns this
 */
proto.fbproto.SensorReading.prototype.clearRawValueB = function() {
  return jspb.Message.setOneofField(this, 53, proto.fbproto.SensorReading.oneofGroups_[1], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.SensorReading.prototype.hasRawValueB = function() {
  return jspb.Message.getField(this, 53) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fbproto.DeviceAttached.prototype.toObject = function(opt_includeInstance) {
  return proto.fbproto.DeviceAttached.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fbproto.DeviceAttached} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.DeviceAttached.toObject = function(includeInstance, msg) {
  var f, obj = {
deviceType: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
controllerId: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
date: (f = msg.getDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fbproto.DeviceAttached}
 */
proto.fbproto.DeviceAttached.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fbproto.DeviceAttached;
  return proto.fbproto.DeviceAttached.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fbproto.DeviceAttached} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fbproto.DeviceAttached}
 */
proto.fbproto.DeviceAttached.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.fbproto.DeviceType} */ (reader.readEnum());
      msg.setDeviceType(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setControllerId(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fbproto.DeviceAttached.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fbproto.DeviceAttached.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fbproto.DeviceAttached} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.DeviceAttached.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {!proto.fbproto.DeviceType} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getDate();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional DeviceType device_type = 1;
 * @return {!proto.fbproto.DeviceType}
 */
proto.fbproto.DeviceAttached.prototype.getDeviceType = function() {
  return /** @type {!proto.fbproto.DeviceType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.fbproto.DeviceType} value
 * @return {!proto.fbproto.DeviceAttached} returns this
 */
proto.fbproto.DeviceAttached.prototype.setDeviceType = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.DeviceAttached} returns this
 */
proto.fbproto.DeviceAttached.prototype.clearDeviceType = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.DeviceAttached.prototype.hasDeviceType = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 controller_id = 2;
 * @return {number}
 */
proto.fbproto.DeviceAttached.prototype.getControllerId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.fbproto.DeviceAttached} returns this
 */
proto.fbproto.DeviceAttached.prototype.setControllerId = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.DeviceAttached} returns this
 */
proto.fbproto.DeviceAttached.prototype.clearControllerId = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.DeviceAttached.prototype.hasControllerId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Timestamp date = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fbproto.DeviceAttached.prototype.getDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fbproto.DeviceAttached} returns this
*/
proto.fbproto.DeviceAttached.prototype.setDate = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fbproto.DeviceAttached} returns this
 */
proto.fbproto.DeviceAttached.prototype.clearDate = function() {
  return this.setDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.DeviceAttached.prototype.hasDate = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fbproto.DeviceRemoved.prototype.toObject = function(opt_includeInstance) {
  return proto.fbproto.DeviceRemoved.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fbproto.DeviceRemoved} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.DeviceRemoved.toObject = function(includeInstance, msg) {
  var f, obj = {
deviceType: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
controllerId: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
date: (f = msg.getDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fbproto.DeviceRemoved}
 */
proto.fbproto.DeviceRemoved.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fbproto.DeviceRemoved;
  return proto.fbproto.DeviceRemoved.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fbproto.DeviceRemoved} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fbproto.DeviceRemoved}
 */
proto.fbproto.DeviceRemoved.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.fbproto.DeviceType} */ (reader.readEnum());
      msg.setDeviceType(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setControllerId(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fbproto.DeviceRemoved.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fbproto.DeviceRemoved.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fbproto.DeviceRemoved} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.DeviceRemoved.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {!proto.fbproto.DeviceType} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getDate();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional DeviceType device_type = 1;
 * @return {!proto.fbproto.DeviceType}
 */
proto.fbproto.DeviceRemoved.prototype.getDeviceType = function() {
  return /** @type {!proto.fbproto.DeviceType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.fbproto.DeviceType} value
 * @return {!proto.fbproto.DeviceRemoved} returns this
 */
proto.fbproto.DeviceRemoved.prototype.setDeviceType = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.DeviceRemoved} returns this
 */
proto.fbproto.DeviceRemoved.prototype.clearDeviceType = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.DeviceRemoved.prototype.hasDeviceType = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 controller_id = 2;
 * @return {number}
 */
proto.fbproto.DeviceRemoved.prototype.getControllerId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.fbproto.DeviceRemoved} returns this
 */
proto.fbproto.DeviceRemoved.prototype.setControllerId = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.DeviceRemoved} returns this
 */
proto.fbproto.DeviceRemoved.prototype.clearControllerId = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.DeviceRemoved.prototype.hasControllerId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Timestamp date = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.fbproto.DeviceRemoved.prototype.getDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.fbproto.DeviceRemoved} returns this
*/
proto.fbproto.DeviceRemoved.prototype.setDate = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fbproto.DeviceRemoved} returns this
 */
proto.fbproto.DeviceRemoved.prototype.clearDate = function() {
  return this.setDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.DeviceRemoved.prototype.hasDate = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.fbproto.SetParam.oneofGroups_ = [[11,12,13]];

/**
 * @enum {number}
 */
proto.fbproto.SetParam.ParamCase = {
  PARAM_NOT_SET: 0,
  VALUE_F: 11,
  VALUE_I32: 12,
  VALUE_B: 13
};

/**
 * @return {proto.fbproto.SetParam.ParamCase}
 */
proto.fbproto.SetParam.prototype.getParamCase = function() {
  return /** @type {proto.fbproto.SetParam.ParamCase} */(jspb.Message.computeOneofCase(this, proto.fbproto.SetParam.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fbproto.SetParam.prototype.toObject = function(opt_includeInstance) {
  return proto.fbproto.SetParam.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fbproto.SetParam} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.SetParam.toObject = function(includeInstance, msg) {
  var f, obj = {
deviceType: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
controllerId: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
valueF: (f = jspb.Message.getOptionalFloatingPointField(msg, 11)) == null ? undefined : f,
valueI32: (f = jspb.Message.getField(msg, 12)) == null ? undefined : f,
valueB: (f = jspb.Message.getBooleanField(msg, 13)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fbproto.SetParam}
 */
proto.fbproto.SetParam.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fbproto.SetParam;
  return proto.fbproto.SetParam.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fbproto.SetParam} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fbproto.SetParam}
 */
proto.fbproto.SetParam.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.fbproto.DeviceType} */ (reader.readEnum());
      msg.setDeviceType(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setControllerId(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setValueF(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setValueI32(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setValueB(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fbproto.SetParam.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fbproto.SetParam.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fbproto.SetParam} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.SetParam.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {!proto.fbproto.DeviceType} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 11));
  if (f != null) {
    writer.writeFloat(
      11,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 12));
  if (f != null) {
    writer.writeInt32(
      12,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 13));
  if (f != null) {
    writer.writeBool(
      13,
      f
    );
  }
};


/**
 * optional DeviceType device_type = 1;
 * @return {!proto.fbproto.DeviceType}
 */
proto.fbproto.SetParam.prototype.getDeviceType = function() {
  return /** @type {!proto.fbproto.DeviceType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.fbproto.DeviceType} value
 * @return {!proto.fbproto.SetParam} returns this
 */
proto.fbproto.SetParam.prototype.setDeviceType = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.SetParam} returns this
 */
proto.fbproto.SetParam.prototype.clearDeviceType = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.SetParam.prototype.hasDeviceType = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 controller_id = 2;
 * @return {number}
 */
proto.fbproto.SetParam.prototype.getControllerId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.fbproto.SetParam} returns this
 */
proto.fbproto.SetParam.prototype.setControllerId = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.SetParam} returns this
 */
proto.fbproto.SetParam.prototype.clearControllerId = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.SetParam.prototype.hasControllerId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional float value_f = 11;
 * @return {number}
 */
proto.fbproto.SetParam.prototype.getValueF = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 11, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.fbproto.SetParam} returns this
 */
proto.fbproto.SetParam.prototype.setValueF = function(value) {
  return jspb.Message.setOneofField(this, 11, proto.fbproto.SetParam.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.SetParam} returns this
 */
proto.fbproto.SetParam.prototype.clearValueF = function() {
  return jspb.Message.setOneofField(this, 11, proto.fbproto.SetParam.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.SetParam.prototype.hasValueF = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional int32 value_i32 = 12;
 * @return {number}
 */
proto.fbproto.SetParam.prototype.getValueI32 = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.fbproto.SetParam} returns this
 */
proto.fbproto.SetParam.prototype.setValueI32 = function(value) {
  return jspb.Message.setOneofField(this, 12, proto.fbproto.SetParam.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.SetParam} returns this
 */
proto.fbproto.SetParam.prototype.clearValueI32 = function() {
  return jspb.Message.setOneofField(this, 12, proto.fbproto.SetParam.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.SetParam.prototype.hasValueI32 = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional bool value_b = 13;
 * @return {boolean}
 */
proto.fbproto.SetParam.prototype.getValueB = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.fbproto.SetParam} returns this
 */
proto.fbproto.SetParam.prototype.setValueB = function(value) {
  return jspb.Message.setOneofField(this, 13, proto.fbproto.SetParam.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.SetParam} returns this
 */
proto.fbproto.SetParam.prototype.clearValueB = function() {
  return jspb.Message.setOneofField(this, 13, proto.fbproto.SetParam.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.SetParam.prototype.hasValueB = function() {
  return jspb.Message.getField(this, 13) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fbproto.CalibratePh.prototype.toObject = function(opt_includeInstance) {
  return proto.fbproto.CalibratePh.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fbproto.CalibratePh} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.CalibratePh.toObject = function(includeInstance, msg) {
  var f, obj = {
controllerId: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
deviceId: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
phReference: (f = jspb.Message.getOptionalFloatingPointField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fbproto.CalibratePh}
 */
proto.fbproto.CalibratePh.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fbproto.CalibratePh;
  return proto.fbproto.CalibratePh.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fbproto.CalibratePh} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fbproto.CalibratePh}
 */
proto.fbproto.CalibratePh.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setControllerId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDeviceId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setPhReference(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fbproto.CalibratePh.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fbproto.CalibratePh.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fbproto.CalibratePh} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.CalibratePh.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeFloat(
      3,
      f
    );
  }
};


/**
 * optional int64 controller_id = 1;
 * @return {number}
 */
proto.fbproto.CalibratePh.prototype.getControllerId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.fbproto.CalibratePh} returns this
 */
proto.fbproto.CalibratePh.prototype.setControllerId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.CalibratePh} returns this
 */
proto.fbproto.CalibratePh.prototype.clearControllerId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.CalibratePh.prototype.hasControllerId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 device_id = 2;
 * @return {number}
 */
proto.fbproto.CalibratePh.prototype.getDeviceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.fbproto.CalibratePh} returns this
 */
proto.fbproto.CalibratePh.prototype.setDeviceId = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.CalibratePh} returns this
 */
proto.fbproto.CalibratePh.prototype.clearDeviceId = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.CalibratePh.prototype.hasDeviceId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional float ph_reference = 3;
 * @return {number}
 */
proto.fbproto.CalibratePh.prototype.getPhReference = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.fbproto.CalibratePh} returns this
 */
proto.fbproto.CalibratePh.prototype.setPhReference = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.CalibratePh} returns this
 */
proto.fbproto.CalibratePh.prototype.clearPhReference = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.CalibratePh.prototype.hasPhReference = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fbproto.CalibratePhResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fbproto.CalibratePhResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fbproto.CalibratePhResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.CalibratePhResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
phmv: (f = jspb.Message.getOptionalFloatingPointField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fbproto.CalibratePhResponse}
 */
proto.fbproto.CalibratePhResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fbproto.CalibratePhResponse;
  return proto.fbproto.CalibratePhResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fbproto.CalibratePhResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fbproto.CalibratePhResponse}
 */
proto.fbproto.CalibratePhResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setPhmv(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fbproto.CalibratePhResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fbproto.CalibratePhResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fbproto.CalibratePhResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.CalibratePhResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeFloat(
      1,
      f
    );
  }
};


/**
 * optional float phmv = 1;
 * @return {number}
 */
proto.fbproto.CalibratePhResponse.prototype.getPhmv = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.fbproto.CalibratePhResponse} returns this
 */
proto.fbproto.CalibratePhResponse.prototype.setPhmv = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.CalibratePhResponse} returns this
 */
proto.fbproto.CalibratePhResponse.prototype.clearPhmv = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.CalibratePhResponse.prototype.hasPhmv = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fbproto.RestartController.prototype.toObject = function(opt_includeInstance) {
  return proto.fbproto.RestartController.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fbproto.RestartController} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.RestartController.toObject = function(includeInstance, msg) {
  var f, obj = {
controllerId: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fbproto.RestartController}
 */
proto.fbproto.RestartController.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fbproto.RestartController;
  return proto.fbproto.RestartController.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fbproto.RestartController} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fbproto.RestartController}
 */
proto.fbproto.RestartController.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setControllerId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fbproto.RestartController.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fbproto.RestartController.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fbproto.RestartController} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.RestartController.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 controller_id = 1;
 * @return {number}
 */
proto.fbproto.RestartController.prototype.getControllerId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.fbproto.RestartController} returns this
 */
proto.fbproto.RestartController.prototype.setControllerId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.RestartController} returns this
 */
proto.fbproto.RestartController.prototype.clearControllerId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.RestartController.prototype.hasControllerId = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fbproto.RestartControllerResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fbproto.RestartControllerResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fbproto.RestartControllerResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.RestartControllerResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
controllerId: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fbproto.RestartControllerResponse}
 */
proto.fbproto.RestartControllerResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fbproto.RestartControllerResponse;
  return proto.fbproto.RestartControllerResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fbproto.RestartControllerResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fbproto.RestartControllerResponse}
 */
proto.fbproto.RestartControllerResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setControllerId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fbproto.RestartControllerResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fbproto.RestartControllerResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fbproto.RestartControllerResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.RestartControllerResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 controller_id = 1;
 * @return {number}
 */
proto.fbproto.RestartControllerResponse.prototype.getControllerId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.fbproto.RestartControllerResponse} returns this
 */
proto.fbproto.RestartControllerResponse.prototype.setControllerId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.RestartControllerResponse} returns this
 */
proto.fbproto.RestartControllerResponse.prototype.clearControllerId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.RestartControllerResponse.prototype.hasControllerId = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fbproto.OtaUpdateInit.prototype.toObject = function(opt_includeInstance) {
  return proto.fbproto.OtaUpdateInit.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fbproto.OtaUpdateInit} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.OtaUpdateInit.toObject = function(includeInstance, msg) {
  var f, obj = {
controllerId: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
version: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
fileSize: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fbproto.OtaUpdateInit}
 */
proto.fbproto.OtaUpdateInit.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fbproto.OtaUpdateInit;
  return proto.fbproto.OtaUpdateInit.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fbproto.OtaUpdateInit} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fbproto.OtaUpdateInit}
 */
proto.fbproto.OtaUpdateInit.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setControllerId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setVersion(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFileSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fbproto.OtaUpdateInit.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fbproto.OtaUpdateInit.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fbproto.OtaUpdateInit} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.OtaUpdateInit.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional int64 controller_id = 1;
 * @return {number}
 */
proto.fbproto.OtaUpdateInit.prototype.getControllerId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.fbproto.OtaUpdateInit} returns this
 */
proto.fbproto.OtaUpdateInit.prototype.setControllerId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.OtaUpdateInit} returns this
 */
proto.fbproto.OtaUpdateInit.prototype.clearControllerId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.OtaUpdateInit.prototype.hasControllerId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 version = 2;
 * @return {number}
 */
proto.fbproto.OtaUpdateInit.prototype.getVersion = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.fbproto.OtaUpdateInit} returns this
 */
proto.fbproto.OtaUpdateInit.prototype.setVersion = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.OtaUpdateInit} returns this
 */
proto.fbproto.OtaUpdateInit.prototype.clearVersion = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.OtaUpdateInit.prototype.hasVersion = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int32 file_size = 3;
 * @return {number}
 */
proto.fbproto.OtaUpdateInit.prototype.getFileSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.fbproto.OtaUpdateInit} returns this
 */
proto.fbproto.OtaUpdateInit.prototype.setFileSize = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.OtaUpdateInit} returns this
 */
proto.fbproto.OtaUpdateInit.prototype.clearFileSize = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.OtaUpdateInit.prototype.hasFileSize = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fbproto.OtaUpdateInitResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fbproto.OtaUpdateInitResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fbproto.OtaUpdateInitResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.OtaUpdateInitResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
controllerId: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
initSuccess: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fbproto.OtaUpdateInitResponse}
 */
proto.fbproto.OtaUpdateInitResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fbproto.OtaUpdateInitResponse;
  return proto.fbproto.OtaUpdateInitResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fbproto.OtaUpdateInitResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fbproto.OtaUpdateInitResponse}
 */
proto.fbproto.OtaUpdateInitResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setControllerId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setInitSuccess(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fbproto.OtaUpdateInitResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fbproto.OtaUpdateInitResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fbproto.OtaUpdateInitResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.OtaUpdateInitResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int64 controller_id = 1;
 * @return {number}
 */
proto.fbproto.OtaUpdateInitResponse.prototype.getControllerId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.fbproto.OtaUpdateInitResponse} returns this
 */
proto.fbproto.OtaUpdateInitResponse.prototype.setControllerId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.OtaUpdateInitResponse} returns this
 */
proto.fbproto.OtaUpdateInitResponse.prototype.clearControllerId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.OtaUpdateInitResponse.prototype.hasControllerId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 init_success = 2;
 * @return {number}
 */
proto.fbproto.OtaUpdateInitResponse.prototype.getInitSuccess = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.fbproto.OtaUpdateInitResponse} returns this
 */
proto.fbproto.OtaUpdateInitResponse.prototype.setInitSuccess = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.OtaUpdateInitResponse} returns this
 */
proto.fbproto.OtaUpdateInitResponse.prototype.clearInitSuccess = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.OtaUpdateInitResponse.prototype.hasInitSuccess = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fbproto.OtaUpdateFile.prototype.toObject = function(opt_includeInstance) {
  return proto.fbproto.OtaUpdateFile.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fbproto.OtaUpdateFile} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.OtaUpdateFile.toObject = function(includeInstance, msg) {
  var f, obj = {
controllerId: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
fileOffset: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
fileData: msg.getFileData_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fbproto.OtaUpdateFile}
 */
proto.fbproto.OtaUpdateFile.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fbproto.OtaUpdateFile;
  return proto.fbproto.OtaUpdateFile.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fbproto.OtaUpdateFile} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fbproto.OtaUpdateFile}
 */
proto.fbproto.OtaUpdateFile.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setControllerId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFileOffset(value);
      break;
    case 3:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setFileData(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fbproto.OtaUpdateFile.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fbproto.OtaUpdateFile.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fbproto.OtaUpdateFile} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.OtaUpdateFile.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = /** @type {!(string|Uint8Array)} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeBytes(
      3,
      f
    );
  }
};


/**
 * optional int64 controller_id = 1;
 * @return {number}
 */
proto.fbproto.OtaUpdateFile.prototype.getControllerId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.fbproto.OtaUpdateFile} returns this
 */
proto.fbproto.OtaUpdateFile.prototype.setControllerId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.OtaUpdateFile} returns this
 */
proto.fbproto.OtaUpdateFile.prototype.clearControllerId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.OtaUpdateFile.prototype.hasControllerId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 file_offset = 2;
 * @return {number}
 */
proto.fbproto.OtaUpdateFile.prototype.getFileOffset = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.fbproto.OtaUpdateFile} returns this
 */
proto.fbproto.OtaUpdateFile.prototype.setFileOffset = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.OtaUpdateFile} returns this
 */
proto.fbproto.OtaUpdateFile.prototype.clearFileOffset = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.OtaUpdateFile.prototype.hasFileOffset = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional bytes file_data = 3;
 * @return {!(string|Uint8Array)}
 */
proto.fbproto.OtaUpdateFile.prototype.getFileData = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * optional bytes file_data = 3;
 * This is a type-conversion wrapper around `getFileData()`
 * @return {string}
 */
proto.fbproto.OtaUpdateFile.prototype.getFileData_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getFileData()));
};


/**
 * optional bytes file_data = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getFileData()`
 * @return {!Uint8Array}
 */
proto.fbproto.OtaUpdateFile.prototype.getFileData_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getFileData()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.fbproto.OtaUpdateFile} returns this
 */
proto.fbproto.OtaUpdateFile.prototype.setFileData = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.OtaUpdateFile} returns this
 */
proto.fbproto.OtaUpdateFile.prototype.clearFileData = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.OtaUpdateFile.prototype.hasFileData = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fbproto.OtaUpdateFileResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fbproto.OtaUpdateFileResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fbproto.OtaUpdateFileResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.OtaUpdateFileResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
controllerId: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
bytesWritten: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fbproto.OtaUpdateFileResponse}
 */
proto.fbproto.OtaUpdateFileResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fbproto.OtaUpdateFileResponse;
  return proto.fbproto.OtaUpdateFileResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fbproto.OtaUpdateFileResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fbproto.OtaUpdateFileResponse}
 */
proto.fbproto.OtaUpdateFileResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setControllerId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setBytesWritten(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fbproto.OtaUpdateFileResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fbproto.OtaUpdateFileResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fbproto.OtaUpdateFileResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.OtaUpdateFileResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int64 controller_id = 1;
 * @return {number}
 */
proto.fbproto.OtaUpdateFileResponse.prototype.getControllerId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.fbproto.OtaUpdateFileResponse} returns this
 */
proto.fbproto.OtaUpdateFileResponse.prototype.setControllerId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.OtaUpdateFileResponse} returns this
 */
proto.fbproto.OtaUpdateFileResponse.prototype.clearControllerId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.OtaUpdateFileResponse.prototype.hasControllerId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 bytes_written = 2;
 * @return {number}
 */
proto.fbproto.OtaUpdateFileResponse.prototype.getBytesWritten = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.fbproto.OtaUpdateFileResponse} returns this
 */
proto.fbproto.OtaUpdateFileResponse.prototype.setBytesWritten = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.OtaUpdateFileResponse} returns this
 */
proto.fbproto.OtaUpdateFileResponse.prototype.clearBytesWritten = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.OtaUpdateFileResponse.prototype.hasBytesWritten = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fbproto.OtaUpdateComplete.prototype.toObject = function(opt_includeInstance) {
  return proto.fbproto.OtaUpdateComplete.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fbproto.OtaUpdateComplete} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.OtaUpdateComplete.toObject = function(includeInstance, msg) {
  var f, obj = {
controllerId: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
hash: msg.getHash_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fbproto.OtaUpdateComplete}
 */
proto.fbproto.OtaUpdateComplete.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fbproto.OtaUpdateComplete;
  return proto.fbproto.OtaUpdateComplete.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fbproto.OtaUpdateComplete} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fbproto.OtaUpdateComplete}
 */
proto.fbproto.OtaUpdateComplete.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setControllerId(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setHash(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fbproto.OtaUpdateComplete.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fbproto.OtaUpdateComplete.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fbproto.OtaUpdateComplete} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.OtaUpdateComplete.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = /** @type {!(string|Uint8Array)} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeBytes(
      2,
      f
    );
  }
};


/**
 * optional int64 controller_id = 1;
 * @return {number}
 */
proto.fbproto.OtaUpdateComplete.prototype.getControllerId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.fbproto.OtaUpdateComplete} returns this
 */
proto.fbproto.OtaUpdateComplete.prototype.setControllerId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.OtaUpdateComplete} returns this
 */
proto.fbproto.OtaUpdateComplete.prototype.clearControllerId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.OtaUpdateComplete.prototype.hasControllerId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bytes hash = 2;
 * @return {!(string|Uint8Array)}
 */
proto.fbproto.OtaUpdateComplete.prototype.getHash = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes hash = 2;
 * This is a type-conversion wrapper around `getHash()`
 * @return {string}
 */
proto.fbproto.OtaUpdateComplete.prototype.getHash_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getHash()));
};


/**
 * optional bytes hash = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getHash()`
 * @return {!Uint8Array}
 */
proto.fbproto.OtaUpdateComplete.prototype.getHash_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getHash()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.fbproto.OtaUpdateComplete} returns this
 */
proto.fbproto.OtaUpdateComplete.prototype.setHash = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.OtaUpdateComplete} returns this
 */
proto.fbproto.OtaUpdateComplete.prototype.clearHash = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.OtaUpdateComplete.prototype.hasHash = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fbproto.OtaUpdateCompleteResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fbproto.OtaUpdateCompleteResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fbproto.OtaUpdateCompleteResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.OtaUpdateCompleteResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
controllerId: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fbproto.OtaUpdateCompleteResponse}
 */
proto.fbproto.OtaUpdateCompleteResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fbproto.OtaUpdateCompleteResponse;
  return proto.fbproto.OtaUpdateCompleteResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fbproto.OtaUpdateCompleteResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fbproto.OtaUpdateCompleteResponse}
 */
proto.fbproto.OtaUpdateCompleteResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setControllerId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fbproto.OtaUpdateCompleteResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fbproto.OtaUpdateCompleteResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fbproto.OtaUpdateCompleteResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.OtaUpdateCompleteResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 controller_id = 1;
 * @return {number}
 */
proto.fbproto.OtaUpdateCompleteResponse.prototype.getControllerId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.fbproto.OtaUpdateCompleteResponse} returns this
 */
proto.fbproto.OtaUpdateCompleteResponse.prototype.setControllerId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.OtaUpdateCompleteResponse} returns this
 */
proto.fbproto.OtaUpdateCompleteResponse.prototype.clearControllerId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.OtaUpdateCompleteResponse.prototype.hasControllerId = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fbproto.ReloadFlows.prototype.toObject = function(opt_includeInstance) {
  return proto.fbproto.ReloadFlows.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fbproto.ReloadFlows} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.ReloadFlows.toObject = function(includeInstance, msg) {
  var f, obj = {
controllerId: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fbproto.ReloadFlows}
 */
proto.fbproto.ReloadFlows.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fbproto.ReloadFlows;
  return proto.fbproto.ReloadFlows.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fbproto.ReloadFlows} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fbproto.ReloadFlows}
 */
proto.fbproto.ReloadFlows.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setControllerId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fbproto.ReloadFlows.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fbproto.ReloadFlows.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fbproto.ReloadFlows} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.ReloadFlows.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 controller_id = 1;
 * @return {number}
 */
proto.fbproto.ReloadFlows.prototype.getControllerId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.fbproto.ReloadFlows} returns this
 */
proto.fbproto.ReloadFlows.prototype.setControllerId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.ReloadFlows} returns this
 */
proto.fbproto.ReloadFlows.prototype.clearControllerId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.ReloadFlows.prototype.hasControllerId = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fbproto.ReloadFlowsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fbproto.ReloadFlowsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fbproto.ReloadFlowsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.ReloadFlowsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
controllerId: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fbproto.ReloadFlowsResponse}
 */
proto.fbproto.ReloadFlowsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fbproto.ReloadFlowsResponse;
  return proto.fbproto.ReloadFlowsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fbproto.ReloadFlowsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fbproto.ReloadFlowsResponse}
 */
proto.fbproto.ReloadFlowsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setControllerId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fbproto.ReloadFlowsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fbproto.ReloadFlowsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fbproto.ReloadFlowsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.ReloadFlowsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 controller_id = 1;
 * @return {number}
 */
proto.fbproto.ReloadFlowsResponse.prototype.getControllerId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.fbproto.ReloadFlowsResponse} returns this
 */
proto.fbproto.ReloadFlowsResponse.prototype.setControllerId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.ReloadFlowsResponse} returns this
 */
proto.fbproto.ReloadFlowsResponse.prototype.clearControllerId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.ReloadFlowsResponse.prototype.hasControllerId = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fbproto.RunDevice.prototype.toObject = function(opt_includeInstance) {
  return proto.fbproto.RunDevice.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fbproto.RunDevice} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.RunDevice.toObject = function(includeInstance, msg) {
  var f, obj = {
controllerId: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
deviceId: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
durationS: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fbproto.RunDevice}
 */
proto.fbproto.RunDevice.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fbproto.RunDevice;
  return proto.fbproto.RunDevice.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fbproto.RunDevice} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fbproto.RunDevice}
 */
proto.fbproto.RunDevice.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setControllerId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDeviceId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDurationS(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fbproto.RunDevice.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fbproto.RunDevice.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fbproto.RunDevice} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.RunDevice.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional int64 controller_id = 1;
 * @return {number}
 */
proto.fbproto.RunDevice.prototype.getControllerId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.fbproto.RunDevice} returns this
 */
proto.fbproto.RunDevice.prototype.setControllerId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.RunDevice} returns this
 */
proto.fbproto.RunDevice.prototype.clearControllerId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.RunDevice.prototype.hasControllerId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 device_id = 2;
 * @return {number}
 */
proto.fbproto.RunDevice.prototype.getDeviceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.fbproto.RunDevice} returns this
 */
proto.fbproto.RunDevice.prototype.setDeviceId = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.RunDevice} returns this
 */
proto.fbproto.RunDevice.prototype.clearDeviceId = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.RunDevice.prototype.hasDeviceId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int32 duration_s = 3;
 * @return {number}
 */
proto.fbproto.RunDevice.prototype.getDurationS = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.fbproto.RunDevice} returns this
 */
proto.fbproto.RunDevice.prototype.setDurationS = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.RunDevice} returns this
 */
proto.fbproto.RunDevice.prototype.clearDurationS = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.RunDevice.prototype.hasDurationS = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fbproto.RunDeviceResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fbproto.RunDeviceResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fbproto.RunDeviceResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.RunDeviceResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
controllerId: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
deviceId: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fbproto.RunDeviceResponse}
 */
proto.fbproto.RunDeviceResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fbproto.RunDeviceResponse;
  return proto.fbproto.RunDeviceResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fbproto.RunDeviceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fbproto.RunDeviceResponse}
 */
proto.fbproto.RunDeviceResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setControllerId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDeviceId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fbproto.RunDeviceResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fbproto.RunDeviceResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fbproto.RunDeviceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.RunDeviceResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional int64 controller_id = 1;
 * @return {number}
 */
proto.fbproto.RunDeviceResponse.prototype.getControllerId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.fbproto.RunDeviceResponse} returns this
 */
proto.fbproto.RunDeviceResponse.prototype.setControllerId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.RunDeviceResponse} returns this
 */
proto.fbproto.RunDeviceResponse.prototype.clearControllerId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.RunDeviceResponse.prototype.hasControllerId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 device_id = 2;
 * @return {number}
 */
proto.fbproto.RunDeviceResponse.prototype.getDeviceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.fbproto.RunDeviceResponse} returns this
 */
proto.fbproto.RunDeviceResponse.prototype.setDeviceId = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.RunDeviceResponse} returns this
 */
proto.fbproto.RunDeviceResponse.prototype.clearDeviceId = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.RunDeviceResponse.prototype.hasDeviceId = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fbproto.GetDevices.prototype.toObject = function(opt_includeInstance) {
  return proto.fbproto.GetDevices.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fbproto.GetDevices} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.GetDevices.toObject = function(includeInstance, msg) {
  var f, obj = {
controllerId: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fbproto.GetDevices}
 */
proto.fbproto.GetDevices.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fbproto.GetDevices;
  return proto.fbproto.GetDevices.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fbproto.GetDevices} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fbproto.GetDevices}
 */
proto.fbproto.GetDevices.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setControllerId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fbproto.GetDevices.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fbproto.GetDevices.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fbproto.GetDevices} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.GetDevices.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 controller_id = 1;
 * @return {number}
 */
proto.fbproto.GetDevices.prototype.getControllerId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.fbproto.GetDevices} returns this
 */
proto.fbproto.GetDevices.prototype.setControllerId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.GetDevices} returns this
 */
proto.fbproto.GetDevices.prototype.clearControllerId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.GetDevices.prototype.hasControllerId = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fbproto.GetDevicesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fbproto.GetDevicesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fbproto.GetDevicesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fbproto.GetDevicesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.GetDevicesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
devicesList: jspb.Message.toObjectList(msg.getDevicesList(),
    proto.fbproto.Device.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fbproto.GetDevicesResponse}
 */
proto.fbproto.GetDevicesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fbproto.GetDevicesResponse;
  return proto.fbproto.GetDevicesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fbproto.GetDevicesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fbproto.GetDevicesResponse}
 */
proto.fbproto.GetDevicesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fbproto.Device;
      reader.readMessage(value,proto.fbproto.Device.deserializeBinaryFromReader);
      msg.addDevices(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fbproto.GetDevicesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fbproto.GetDevicesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fbproto.GetDevicesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.GetDevicesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDevicesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.fbproto.Device.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Device devices = 1;
 * @return {!Array<!proto.fbproto.Device>}
 */
proto.fbproto.GetDevicesResponse.prototype.getDevicesList = function() {
  return /** @type{!Array<!proto.fbproto.Device>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fbproto.Device, 1));
};


/**
 * @param {!Array<!proto.fbproto.Device>} value
 * @return {!proto.fbproto.GetDevicesResponse} returns this
*/
proto.fbproto.GetDevicesResponse.prototype.setDevicesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.fbproto.Device=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fbproto.Device}
 */
proto.fbproto.GetDevicesResponse.prototype.addDevices = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.fbproto.Device, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fbproto.GetDevicesResponse} returns this
 */
proto.fbproto.GetDevicesResponse.prototype.clearDevicesList = function() {
  return this.setDevicesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fbproto.GetFlows.prototype.toObject = function(opt_includeInstance) {
  return proto.fbproto.GetFlows.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fbproto.GetFlows} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.GetFlows.toObject = function(includeInstance, msg) {
  var f, obj = {
controllerId: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fbproto.GetFlows}
 */
proto.fbproto.GetFlows.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fbproto.GetFlows;
  return proto.fbproto.GetFlows.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fbproto.GetFlows} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fbproto.GetFlows}
 */
proto.fbproto.GetFlows.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setControllerId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fbproto.GetFlows.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fbproto.GetFlows.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fbproto.GetFlows} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.GetFlows.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 controller_id = 1;
 * @return {number}
 */
proto.fbproto.GetFlows.prototype.getControllerId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.fbproto.GetFlows} returns this
 */
proto.fbproto.GetFlows.prototype.setControllerId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.GetFlows} returns this
 */
proto.fbproto.GetFlows.prototype.clearControllerId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.GetFlows.prototype.hasControllerId = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fbproto.GetFlowsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fbproto.GetFlowsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fbproto.GetFlowsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.GetFlowsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
nodes: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
edges: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fbproto.GetFlowsResponse}
 */
proto.fbproto.GetFlowsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fbproto.GetFlowsResponse;
  return proto.fbproto.GetFlowsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fbproto.GetFlowsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fbproto.GetFlowsResponse}
 */
proto.fbproto.GetFlowsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setNodes(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEdges(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fbproto.GetFlowsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fbproto.GetFlowsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fbproto.GetFlowsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.GetFlowsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string nodes = 1;
 * @return {string}
 */
proto.fbproto.GetFlowsResponse.prototype.getNodes = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.fbproto.GetFlowsResponse} returns this
 */
proto.fbproto.GetFlowsResponse.prototype.setNodes = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.GetFlowsResponse} returns this
 */
proto.fbproto.GetFlowsResponse.prototype.clearNodes = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.GetFlowsResponse.prototype.hasNodes = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string edges = 2;
 * @return {string}
 */
proto.fbproto.GetFlowsResponse.prototype.getEdges = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.fbproto.GetFlowsResponse} returns this
 */
proto.fbproto.GetFlowsResponse.prototype.setEdges = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.GetFlowsResponse} returns this
 */
proto.fbproto.GetFlowsResponse.prototype.clearEdges = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.GetFlowsResponse.prototype.hasEdges = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fbproto.GetPhCalibration.prototype.toObject = function(opt_includeInstance) {
  return proto.fbproto.GetPhCalibration.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fbproto.GetPhCalibration} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.GetPhCalibration.toObject = function(includeInstance, msg) {
  var f, obj = {
deviceId: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
phReference: (f = jspb.Message.getOptionalFloatingPointField(msg, 2)) == null ? undefined : f,
controllerId: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fbproto.GetPhCalibration}
 */
proto.fbproto.GetPhCalibration.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fbproto.GetPhCalibration;
  return proto.fbproto.GetPhCalibration.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fbproto.GetPhCalibration} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fbproto.GetPhCalibration}
 */
proto.fbproto.GetPhCalibration.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDeviceId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setPhReference(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setControllerId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fbproto.GetPhCalibration.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fbproto.GetPhCalibration.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fbproto.GetPhCalibration} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.GetPhCalibration.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeFloat(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeInt64(
      3,
      f
    );
  }
};


/**
 * optional int64 device_id = 1;
 * @return {number}
 */
proto.fbproto.GetPhCalibration.prototype.getDeviceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.fbproto.GetPhCalibration} returns this
 */
proto.fbproto.GetPhCalibration.prototype.setDeviceId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.GetPhCalibration} returns this
 */
proto.fbproto.GetPhCalibration.prototype.clearDeviceId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.GetPhCalibration.prototype.hasDeviceId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional float ph_reference = 2;
 * @return {number}
 */
proto.fbproto.GetPhCalibration.prototype.getPhReference = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.fbproto.GetPhCalibration} returns this
 */
proto.fbproto.GetPhCalibration.prototype.setPhReference = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.GetPhCalibration} returns this
 */
proto.fbproto.GetPhCalibration.prototype.clearPhReference = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.GetPhCalibration.prototype.hasPhReference = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int64 controller_id = 3;
 * @return {number}
 */
proto.fbproto.GetPhCalibration.prototype.getControllerId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.fbproto.GetPhCalibration} returns this
 */
proto.fbproto.GetPhCalibration.prototype.setControllerId = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.GetPhCalibration} returns this
 */
proto.fbproto.GetPhCalibration.prototype.clearControllerId = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.GetPhCalibration.prototype.hasControllerId = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fbproto.GetPhCalibrationResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fbproto.GetPhCalibrationResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fbproto.GetPhCalibrationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.GetPhCalibrationResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
deviceId: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
phReference: (f = jspb.Message.getOptionalFloatingPointField(msg, 2)) == null ? undefined : f,
phmv: (f = jspb.Message.getOptionalFloatingPointField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fbproto.GetPhCalibrationResponse}
 */
proto.fbproto.GetPhCalibrationResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fbproto.GetPhCalibrationResponse;
  return proto.fbproto.GetPhCalibrationResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fbproto.GetPhCalibrationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fbproto.GetPhCalibrationResponse}
 */
proto.fbproto.GetPhCalibrationResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDeviceId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setPhReference(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setPhmv(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fbproto.GetPhCalibrationResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fbproto.GetPhCalibrationResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fbproto.GetPhCalibrationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.GetPhCalibrationResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeFloat(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeFloat(
      3,
      f
    );
  }
};


/**
 * optional int64 device_id = 1;
 * @return {number}
 */
proto.fbproto.GetPhCalibrationResponse.prototype.getDeviceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.fbproto.GetPhCalibrationResponse} returns this
 */
proto.fbproto.GetPhCalibrationResponse.prototype.setDeviceId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.GetPhCalibrationResponse} returns this
 */
proto.fbproto.GetPhCalibrationResponse.prototype.clearDeviceId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.GetPhCalibrationResponse.prototype.hasDeviceId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional float ph_reference = 2;
 * @return {number}
 */
proto.fbproto.GetPhCalibrationResponse.prototype.getPhReference = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.fbproto.GetPhCalibrationResponse} returns this
 */
proto.fbproto.GetPhCalibrationResponse.prototype.setPhReference = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.GetPhCalibrationResponse} returns this
 */
proto.fbproto.GetPhCalibrationResponse.prototype.clearPhReference = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.GetPhCalibrationResponse.prototype.hasPhReference = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional float phmv = 3;
 * @return {number}
 */
proto.fbproto.GetPhCalibrationResponse.prototype.getPhmv = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.fbproto.GetPhCalibrationResponse} returns this
 */
proto.fbproto.GetPhCalibrationResponse.prototype.setPhmv = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.GetPhCalibrationResponse} returns this
 */
proto.fbproto.GetPhCalibrationResponse.prototype.clearPhmv = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.GetPhCalibrationResponse.prototype.hasPhmv = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fbproto.GetDeviceAssembliesDevices.prototype.toObject = function(opt_includeInstance) {
  return proto.fbproto.GetDeviceAssembliesDevices.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fbproto.GetDeviceAssembliesDevices} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.GetDeviceAssembliesDevices.toObject = function(includeInstance, msg) {
  var f, obj = {
controllerId: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fbproto.GetDeviceAssembliesDevices}
 */
proto.fbproto.GetDeviceAssembliesDevices.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fbproto.GetDeviceAssembliesDevices;
  return proto.fbproto.GetDeviceAssembliesDevices.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fbproto.GetDeviceAssembliesDevices} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fbproto.GetDeviceAssembliesDevices}
 */
proto.fbproto.GetDeviceAssembliesDevices.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setControllerId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fbproto.GetDeviceAssembliesDevices.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fbproto.GetDeviceAssembliesDevices.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fbproto.GetDeviceAssembliesDevices} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.GetDeviceAssembliesDevices.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 controller_id = 1;
 * @return {number}
 */
proto.fbproto.GetDeviceAssembliesDevices.prototype.getControllerId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.fbproto.GetDeviceAssembliesDevices} returns this
 */
proto.fbproto.GetDeviceAssembliesDevices.prototype.setControllerId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.GetDeviceAssembliesDevices} returns this
 */
proto.fbproto.GetDeviceAssembliesDevices.prototype.clearControllerId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.GetDeviceAssembliesDevices.prototype.hasControllerId = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.fbproto.GetDeviceAssembliesDevicesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fbproto.GetDeviceAssembliesDevicesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.fbproto.GetDeviceAssembliesDevicesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fbproto.GetDeviceAssembliesDevicesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.GetDeviceAssembliesDevicesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
deviceAssembliesList: jspb.Message.toObjectList(msg.getDeviceAssembliesList(),
    proto.fbproto.DeviceAssembly.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fbproto.GetDeviceAssembliesDevicesResponse}
 */
proto.fbproto.GetDeviceAssembliesDevicesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fbproto.GetDeviceAssembliesDevicesResponse;
  return proto.fbproto.GetDeviceAssembliesDevicesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fbproto.GetDeviceAssembliesDevicesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fbproto.GetDeviceAssembliesDevicesResponse}
 */
proto.fbproto.GetDeviceAssembliesDevicesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.fbproto.DeviceAssembly;
      reader.readMessage(value,proto.fbproto.DeviceAssembly.deserializeBinaryFromReader);
      msg.addDeviceAssemblies(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fbproto.GetDeviceAssembliesDevicesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fbproto.GetDeviceAssembliesDevicesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fbproto.GetDeviceAssembliesDevicesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.GetDeviceAssembliesDevicesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDeviceAssembliesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.fbproto.DeviceAssembly.serializeBinaryToWriter
    );
  }
};


/**
 * repeated DeviceAssembly device_assemblies = 1;
 * @return {!Array<!proto.fbproto.DeviceAssembly>}
 */
proto.fbproto.GetDeviceAssembliesDevicesResponse.prototype.getDeviceAssembliesList = function() {
  return /** @type{!Array<!proto.fbproto.DeviceAssembly>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.fbproto.DeviceAssembly, 1));
};


/**
 * @param {!Array<!proto.fbproto.DeviceAssembly>} value
 * @return {!proto.fbproto.GetDeviceAssembliesDevicesResponse} returns this
*/
proto.fbproto.GetDeviceAssembliesDevicesResponse.prototype.setDeviceAssembliesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.fbproto.DeviceAssembly=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fbproto.DeviceAssembly}
 */
proto.fbproto.GetDeviceAssembliesDevicesResponse.prototype.addDeviceAssemblies = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.fbproto.DeviceAssembly, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fbproto.GetDeviceAssembliesDevicesResponse} returns this
 */
proto.fbproto.GetDeviceAssembliesDevicesResponse.prototype.clearDeviceAssembliesList = function() {
  return this.setDeviceAssembliesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fbproto.GenerateFakeSensorReading.prototype.toObject = function(opt_includeInstance) {
  return proto.fbproto.GenerateFakeSensorReading.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fbproto.GenerateFakeSensorReading} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.GenerateFakeSensorReading.toObject = function(includeInstance, msg) {
  var f, obj = {
readingType: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
offset: (f = jspb.Message.getOptionalFloatingPointField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fbproto.GenerateFakeSensorReading}
 */
proto.fbproto.GenerateFakeSensorReading.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fbproto.GenerateFakeSensorReading;
  return proto.fbproto.GenerateFakeSensorReading.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fbproto.GenerateFakeSensorReading} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fbproto.GenerateFakeSensorReading}
 */
proto.fbproto.GenerateFakeSensorReading.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.fbproto.ReadingType} */ (reader.readEnum());
      msg.setReadingType(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setOffset(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fbproto.GenerateFakeSensorReading.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fbproto.GenerateFakeSensorReading.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fbproto.GenerateFakeSensorReading} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.GenerateFakeSensorReading.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {!proto.fbproto.ReadingType} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeFloat(
      2,
      f
    );
  }
};


/**
 * optional ReadingType reading_type = 1;
 * @return {!proto.fbproto.ReadingType}
 */
proto.fbproto.GenerateFakeSensorReading.prototype.getReadingType = function() {
  return /** @type {!proto.fbproto.ReadingType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.fbproto.ReadingType} value
 * @return {!proto.fbproto.GenerateFakeSensorReading} returns this
 */
proto.fbproto.GenerateFakeSensorReading.prototype.setReadingType = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.GenerateFakeSensorReading} returns this
 */
proto.fbproto.GenerateFakeSensorReading.prototype.clearReadingType = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.GenerateFakeSensorReading.prototype.hasReadingType = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional float offset = 2;
 * @return {number}
 */
proto.fbproto.GenerateFakeSensorReading.prototype.getOffset = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.fbproto.GenerateFakeSensorReading} returns this
 */
proto.fbproto.GenerateFakeSensorReading.prototype.setOffset = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.GenerateFakeSensorReading} returns this
 */
proto.fbproto.GenerateFakeSensorReading.prototype.clearOffset = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.GenerateFakeSensorReading.prototype.hasOffset = function() {
  return jspb.Message.getField(this, 2) != null;
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.fbproto.BLEWrapper.oneofGroups_ = [[11,22,23,24,25,26,27,28,29]];

/**
 * @enum {number}
 */
proto.fbproto.BLEWrapper.ContentCase = {
  CONTENT_NOT_SET: 0,
  RESPONSE: 11,
  SWP: 22,
  SCID: 23,
  SMP: 24,
  AD: 25,
  RD: 26,
  AT: 27,
  RT: 28,
  SEK: 29
};

/**
 * @return {proto.fbproto.BLEWrapper.ContentCase}
 */
proto.fbproto.BLEWrapper.prototype.getContentCase = function() {
  return /** @type {proto.fbproto.BLEWrapper.ContentCase} */(jspb.Message.computeOneofCase(this, proto.fbproto.BLEWrapper.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fbproto.BLEWrapper.prototype.toObject = function(opt_includeInstance) {
  return proto.fbproto.BLEWrapper.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fbproto.BLEWrapper} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.BLEWrapper.toObject = function(includeInstance, msg) {
  var f, obj = {
messageType: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
response: (f = msg.getResponse()) && proto.fbproto.Response.toObject(includeInstance, f),
swp: (f = msg.getSwp()) && proto.fbproto.SetWifiParams.toObject(includeInstance, f),
scid: (f = msg.getScid()) && proto.fbproto.SetControllerId.toObject(includeInstance, f),
smp: (f = msg.getSmp()) && proto.fbproto.SetMqttPassword.toObject(includeInstance, f),
ad: (f = msg.getAd()) && proto.fbproto.AddDevice.toObject(includeInstance, f),
rd: (f = msg.getRd()) && proto.fbproto.RemoveDevice.toObject(includeInstance, f),
at: (f = msg.getAt()) && proto.fbproto.AddTrigger.toObject(includeInstance, f),
rt: (f = msg.getRt()) && proto.fbproto.RemoveTrigger.toObject(includeInstance, f),
sek: (f = msg.getSek()) && proto.fbproto.SetEncKey.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fbproto.BLEWrapper}
 */
proto.fbproto.BLEWrapper.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fbproto.BLEWrapper;
  return proto.fbproto.BLEWrapper.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fbproto.BLEWrapper} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fbproto.BLEWrapper}
 */
proto.fbproto.BLEWrapper.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.fbproto.BLEWrapper.MessageType} */ (reader.readEnum());
      msg.setMessageType(value);
      break;
    case 11:
      var value = new proto.fbproto.Response;
      reader.readMessage(value,proto.fbproto.Response.deserializeBinaryFromReader);
      msg.setResponse(value);
      break;
    case 22:
      var value = new proto.fbproto.SetWifiParams;
      reader.readMessage(value,proto.fbproto.SetWifiParams.deserializeBinaryFromReader);
      msg.setSwp(value);
      break;
    case 23:
      var value = new proto.fbproto.SetControllerId;
      reader.readMessage(value,proto.fbproto.SetControllerId.deserializeBinaryFromReader);
      msg.setScid(value);
      break;
    case 24:
      var value = new proto.fbproto.SetMqttPassword;
      reader.readMessage(value,proto.fbproto.SetMqttPassword.deserializeBinaryFromReader);
      msg.setSmp(value);
      break;
    case 25:
      var value = new proto.fbproto.AddDevice;
      reader.readMessage(value,proto.fbproto.AddDevice.deserializeBinaryFromReader);
      msg.setAd(value);
      break;
    case 26:
      var value = new proto.fbproto.RemoveDevice;
      reader.readMessage(value,proto.fbproto.RemoveDevice.deserializeBinaryFromReader);
      msg.setRd(value);
      break;
    case 27:
      var value = new proto.fbproto.AddTrigger;
      reader.readMessage(value,proto.fbproto.AddTrigger.deserializeBinaryFromReader);
      msg.setAt(value);
      break;
    case 28:
      var value = new proto.fbproto.RemoveTrigger;
      reader.readMessage(value,proto.fbproto.RemoveTrigger.deserializeBinaryFromReader);
      msg.setRt(value);
      break;
    case 29:
      var value = new proto.fbproto.SetEncKey;
      reader.readMessage(value,proto.fbproto.SetEncKey.deserializeBinaryFromReader);
      msg.setSek(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fbproto.BLEWrapper.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fbproto.BLEWrapper.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fbproto.BLEWrapper} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.BLEWrapper.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {!proto.fbproto.BLEWrapper.MessageType} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getResponse();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      proto.fbproto.Response.serializeBinaryToWriter
    );
  }
  f = message.getSwp();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      proto.fbproto.SetWifiParams.serializeBinaryToWriter
    );
  }
  f = message.getScid();
  if (f != null) {
    writer.writeMessage(
      23,
      f,
      proto.fbproto.SetControllerId.serializeBinaryToWriter
    );
  }
  f = message.getSmp();
  if (f != null) {
    writer.writeMessage(
      24,
      f,
      proto.fbproto.SetMqttPassword.serializeBinaryToWriter
    );
  }
  f = message.getAd();
  if (f != null) {
    writer.writeMessage(
      25,
      f,
      proto.fbproto.AddDevice.serializeBinaryToWriter
    );
  }
  f = message.getRd();
  if (f != null) {
    writer.writeMessage(
      26,
      f,
      proto.fbproto.RemoveDevice.serializeBinaryToWriter
    );
  }
  f = message.getAt();
  if (f != null) {
    writer.writeMessage(
      27,
      f,
      proto.fbproto.AddTrigger.serializeBinaryToWriter
    );
  }
  f = message.getRt();
  if (f != null) {
    writer.writeMessage(
      28,
      f,
      proto.fbproto.RemoveTrigger.serializeBinaryToWriter
    );
  }
  f = message.getSek();
  if (f != null) {
    writer.writeMessage(
      29,
      f,
      proto.fbproto.SetEncKey.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.fbproto.BLEWrapper.MessageType = {
  BLE_MSG_NONE: 0,
  BLE_MSG_RESPONSE: 11,
  BLE_MSG_SET_WIFI_PARAMS: 22,
  BLE_MSG_SET_CONTROLLERID: 23,
  BLE_MSG_SET_MQTT_PWD: 24,
  BLE_MSG_ADD_DEVICE: 25,
  BLE_MSG_REMOVE_DEVICE: 26,
  BLE_MSG_ADD_TRIGGER: 27,
  BLE_MSG_REMOVE_TRIGGER: 28
};

/**
 * optional MessageType message_type = 1;
 * @return {!proto.fbproto.BLEWrapper.MessageType}
 */
proto.fbproto.BLEWrapper.prototype.getMessageType = function() {
  return /** @type {!proto.fbproto.BLEWrapper.MessageType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.fbproto.BLEWrapper.MessageType} value
 * @return {!proto.fbproto.BLEWrapper} returns this
 */
proto.fbproto.BLEWrapper.prototype.setMessageType = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.BLEWrapper} returns this
 */
proto.fbproto.BLEWrapper.prototype.clearMessageType = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.BLEWrapper.prototype.hasMessageType = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Response response = 11;
 * @return {?proto.fbproto.Response}
 */
proto.fbproto.BLEWrapper.prototype.getResponse = function() {
  return /** @type{?proto.fbproto.Response} */ (
    jspb.Message.getWrapperField(this, proto.fbproto.Response, 11));
};


/**
 * @param {?proto.fbproto.Response|undefined} value
 * @return {!proto.fbproto.BLEWrapper} returns this
*/
proto.fbproto.BLEWrapper.prototype.setResponse = function(value) {
  return jspb.Message.setOneofWrapperField(this, 11, proto.fbproto.BLEWrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fbproto.BLEWrapper} returns this
 */
proto.fbproto.BLEWrapper.prototype.clearResponse = function() {
  return this.setResponse(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.BLEWrapper.prototype.hasResponse = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional SetWifiParams swp = 22;
 * @return {?proto.fbproto.SetWifiParams}
 */
proto.fbproto.BLEWrapper.prototype.getSwp = function() {
  return /** @type{?proto.fbproto.SetWifiParams} */ (
    jspb.Message.getWrapperField(this, proto.fbproto.SetWifiParams, 22));
};


/**
 * @param {?proto.fbproto.SetWifiParams|undefined} value
 * @return {!proto.fbproto.BLEWrapper} returns this
*/
proto.fbproto.BLEWrapper.prototype.setSwp = function(value) {
  return jspb.Message.setOneofWrapperField(this, 22, proto.fbproto.BLEWrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fbproto.BLEWrapper} returns this
 */
proto.fbproto.BLEWrapper.prototype.clearSwp = function() {
  return this.setSwp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.BLEWrapper.prototype.hasSwp = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional SetControllerId scid = 23;
 * @return {?proto.fbproto.SetControllerId}
 */
proto.fbproto.BLEWrapper.prototype.getScid = function() {
  return /** @type{?proto.fbproto.SetControllerId} */ (
    jspb.Message.getWrapperField(this, proto.fbproto.SetControllerId, 23));
};


/**
 * @param {?proto.fbproto.SetControllerId|undefined} value
 * @return {!proto.fbproto.BLEWrapper} returns this
*/
proto.fbproto.BLEWrapper.prototype.setScid = function(value) {
  return jspb.Message.setOneofWrapperField(this, 23, proto.fbproto.BLEWrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fbproto.BLEWrapper} returns this
 */
proto.fbproto.BLEWrapper.prototype.clearScid = function() {
  return this.setScid(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.BLEWrapper.prototype.hasScid = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional SetMqttPassword smp = 24;
 * @return {?proto.fbproto.SetMqttPassword}
 */
proto.fbproto.BLEWrapper.prototype.getSmp = function() {
  return /** @type{?proto.fbproto.SetMqttPassword} */ (
    jspb.Message.getWrapperField(this, proto.fbproto.SetMqttPassword, 24));
};


/**
 * @param {?proto.fbproto.SetMqttPassword|undefined} value
 * @return {!proto.fbproto.BLEWrapper} returns this
*/
proto.fbproto.BLEWrapper.prototype.setSmp = function(value) {
  return jspb.Message.setOneofWrapperField(this, 24, proto.fbproto.BLEWrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fbproto.BLEWrapper} returns this
 */
proto.fbproto.BLEWrapper.prototype.clearSmp = function() {
  return this.setSmp(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.BLEWrapper.prototype.hasSmp = function() {
  return jspb.Message.getField(this, 24) != null;
};


/**
 * optional AddDevice ad = 25;
 * @return {?proto.fbproto.AddDevice}
 */
proto.fbproto.BLEWrapper.prototype.getAd = function() {
  return /** @type{?proto.fbproto.AddDevice} */ (
    jspb.Message.getWrapperField(this, proto.fbproto.AddDevice, 25));
};


/**
 * @param {?proto.fbproto.AddDevice|undefined} value
 * @return {!proto.fbproto.BLEWrapper} returns this
*/
proto.fbproto.BLEWrapper.prototype.setAd = function(value) {
  return jspb.Message.setOneofWrapperField(this, 25, proto.fbproto.BLEWrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fbproto.BLEWrapper} returns this
 */
proto.fbproto.BLEWrapper.prototype.clearAd = function() {
  return this.setAd(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.BLEWrapper.prototype.hasAd = function() {
  return jspb.Message.getField(this, 25) != null;
};


/**
 * optional RemoveDevice rd = 26;
 * @return {?proto.fbproto.RemoveDevice}
 */
proto.fbproto.BLEWrapper.prototype.getRd = function() {
  return /** @type{?proto.fbproto.RemoveDevice} */ (
    jspb.Message.getWrapperField(this, proto.fbproto.RemoveDevice, 26));
};


/**
 * @param {?proto.fbproto.RemoveDevice|undefined} value
 * @return {!proto.fbproto.BLEWrapper} returns this
*/
proto.fbproto.BLEWrapper.prototype.setRd = function(value) {
  return jspb.Message.setOneofWrapperField(this, 26, proto.fbproto.BLEWrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fbproto.BLEWrapper} returns this
 */
proto.fbproto.BLEWrapper.prototype.clearRd = function() {
  return this.setRd(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.BLEWrapper.prototype.hasRd = function() {
  return jspb.Message.getField(this, 26) != null;
};


/**
 * optional AddTrigger at = 27;
 * @return {?proto.fbproto.AddTrigger}
 */
proto.fbproto.BLEWrapper.prototype.getAt = function() {
  return /** @type{?proto.fbproto.AddTrigger} */ (
    jspb.Message.getWrapperField(this, proto.fbproto.AddTrigger, 27));
};


/**
 * @param {?proto.fbproto.AddTrigger|undefined} value
 * @return {!proto.fbproto.BLEWrapper} returns this
*/
proto.fbproto.BLEWrapper.prototype.setAt = function(value) {
  return jspb.Message.setOneofWrapperField(this, 27, proto.fbproto.BLEWrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fbproto.BLEWrapper} returns this
 */
proto.fbproto.BLEWrapper.prototype.clearAt = function() {
  return this.setAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.BLEWrapper.prototype.hasAt = function() {
  return jspb.Message.getField(this, 27) != null;
};


/**
 * optional RemoveTrigger rt = 28;
 * @return {?proto.fbproto.RemoveTrigger}
 */
proto.fbproto.BLEWrapper.prototype.getRt = function() {
  return /** @type{?proto.fbproto.RemoveTrigger} */ (
    jspb.Message.getWrapperField(this, proto.fbproto.RemoveTrigger, 28));
};


/**
 * @param {?proto.fbproto.RemoveTrigger|undefined} value
 * @return {!proto.fbproto.BLEWrapper} returns this
*/
proto.fbproto.BLEWrapper.prototype.setRt = function(value) {
  return jspb.Message.setOneofWrapperField(this, 28, proto.fbproto.BLEWrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fbproto.BLEWrapper} returns this
 */
proto.fbproto.BLEWrapper.prototype.clearRt = function() {
  return this.setRt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.BLEWrapper.prototype.hasRt = function() {
  return jspb.Message.getField(this, 28) != null;
};


/**
 * optional SetEncKey sek = 29;
 * @return {?proto.fbproto.SetEncKey}
 */
proto.fbproto.BLEWrapper.prototype.getSek = function() {
  return /** @type{?proto.fbproto.SetEncKey} */ (
    jspb.Message.getWrapperField(this, proto.fbproto.SetEncKey, 29));
};


/**
 * @param {?proto.fbproto.SetEncKey|undefined} value
 * @return {!proto.fbproto.BLEWrapper} returns this
*/
proto.fbproto.BLEWrapper.prototype.setSek = function(value) {
  return jspb.Message.setOneofWrapperField(this, 29, proto.fbproto.BLEWrapper.oneofGroups_[0], value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.fbproto.BLEWrapper} returns this
 */
proto.fbproto.BLEWrapper.prototype.clearSek = function() {
  return this.setSek(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.BLEWrapper.prototype.hasSek = function() {
  return jspb.Message.getField(this, 29) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fbproto.SetWifiParams.prototype.toObject = function(opt_includeInstance) {
  return proto.fbproto.SetWifiParams.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fbproto.SetWifiParams} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.SetWifiParams.toObject = function(includeInstance, msg) {
  var f, obj = {
ssid: msg.getSsid_asB64(),
password: msg.getPassword_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fbproto.SetWifiParams}
 */
proto.fbproto.SetWifiParams.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fbproto.SetWifiParams;
  return proto.fbproto.SetWifiParams.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fbproto.SetWifiParams} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fbproto.SetWifiParams}
 */
proto.fbproto.SetWifiParams.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setSsid(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setPassword(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fbproto.SetWifiParams.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fbproto.SetWifiParams.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fbproto.SetWifiParams} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.SetWifiParams.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {!(string|Uint8Array)} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = /** @type {!(string|Uint8Array)} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeBytes(
      2,
      f
    );
  }
};


/**
 * optional bytes ssid = 1;
 * @return {!(string|Uint8Array)}
 */
proto.fbproto.SetWifiParams.prototype.getSsid = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes ssid = 1;
 * This is a type-conversion wrapper around `getSsid()`
 * @return {string}
 */
proto.fbproto.SetWifiParams.prototype.getSsid_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getSsid()));
};


/**
 * optional bytes ssid = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getSsid()`
 * @return {!Uint8Array}
 */
proto.fbproto.SetWifiParams.prototype.getSsid_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getSsid()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.fbproto.SetWifiParams} returns this
 */
proto.fbproto.SetWifiParams.prototype.setSsid = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.SetWifiParams} returns this
 */
proto.fbproto.SetWifiParams.prototype.clearSsid = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.SetWifiParams.prototype.hasSsid = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bytes password = 2;
 * @return {!(string|Uint8Array)}
 */
proto.fbproto.SetWifiParams.prototype.getPassword = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes password = 2;
 * This is a type-conversion wrapper around `getPassword()`
 * @return {string}
 */
proto.fbproto.SetWifiParams.prototype.getPassword_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getPassword()));
};


/**
 * optional bytes password = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getPassword()`
 * @return {!Uint8Array}
 */
proto.fbproto.SetWifiParams.prototype.getPassword_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getPassword()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.fbproto.SetWifiParams} returns this
 */
proto.fbproto.SetWifiParams.prototype.setPassword = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.SetWifiParams} returns this
 */
proto.fbproto.SetWifiParams.prototype.clearPassword = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.SetWifiParams.prototype.hasPassword = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fbproto.SetControllerId.prototype.toObject = function(opt_includeInstance) {
  return proto.fbproto.SetControllerId.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fbproto.SetControllerId} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.SetControllerId.toObject = function(includeInstance, msg) {
  var f, obj = {
controllerId: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
mqttPassword: msg.getMqttPassword_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fbproto.SetControllerId}
 */
proto.fbproto.SetControllerId.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fbproto.SetControllerId;
  return proto.fbproto.SetControllerId.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fbproto.SetControllerId} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fbproto.SetControllerId}
 */
proto.fbproto.SetControllerId.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setControllerId(value);
      break;
    case 2:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setMqttPassword(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fbproto.SetControllerId.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fbproto.SetControllerId.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fbproto.SetControllerId} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.SetControllerId.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = /** @type {!(string|Uint8Array)} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeBytes(
      2,
      f
    );
  }
};


/**
 * optional int64 controller_id = 1;
 * @return {number}
 */
proto.fbproto.SetControllerId.prototype.getControllerId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.fbproto.SetControllerId} returns this
 */
proto.fbproto.SetControllerId.prototype.setControllerId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.SetControllerId} returns this
 */
proto.fbproto.SetControllerId.prototype.clearControllerId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.SetControllerId.prototype.hasControllerId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bytes mqtt_password = 2;
 * @return {!(string|Uint8Array)}
 */
proto.fbproto.SetControllerId.prototype.getMqttPassword = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * optional bytes mqtt_password = 2;
 * This is a type-conversion wrapper around `getMqttPassword()`
 * @return {string}
 */
proto.fbproto.SetControllerId.prototype.getMqttPassword_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getMqttPassword()));
};


/**
 * optional bytes mqtt_password = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getMqttPassword()`
 * @return {!Uint8Array}
 */
proto.fbproto.SetControllerId.prototype.getMqttPassword_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getMqttPassword()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.fbproto.SetControllerId} returns this
 */
proto.fbproto.SetControllerId.prototype.setMqttPassword = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.SetControllerId} returns this
 */
proto.fbproto.SetControllerId.prototype.clearMqttPassword = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.SetControllerId.prototype.hasMqttPassword = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fbproto.SetMqttPassword.prototype.toObject = function(opt_includeInstance) {
  return proto.fbproto.SetMqttPassword.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fbproto.SetMqttPassword} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.SetMqttPassword.toObject = function(includeInstance, msg) {
  var f, obj = {
password: msg.getPassword_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fbproto.SetMqttPassword}
 */
proto.fbproto.SetMqttPassword.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fbproto.SetMqttPassword;
  return proto.fbproto.SetMqttPassword.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fbproto.SetMqttPassword} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fbproto.SetMqttPassword}
 */
proto.fbproto.SetMqttPassword.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setPassword(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fbproto.SetMqttPassword.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fbproto.SetMqttPassword.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fbproto.SetMqttPassword} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.SetMqttPassword.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {!(string|Uint8Array)} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeBytes(
      1,
      f
    );
  }
};


/**
 * optional bytes password = 1;
 * @return {!(string|Uint8Array)}
 */
proto.fbproto.SetMqttPassword.prototype.getPassword = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes password = 1;
 * This is a type-conversion wrapper around `getPassword()`
 * @return {string}
 */
proto.fbproto.SetMqttPassword.prototype.getPassword_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getPassword()));
};


/**
 * optional bytes password = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getPassword()`
 * @return {!Uint8Array}
 */
proto.fbproto.SetMqttPassword.prototype.getPassword_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getPassword()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.fbproto.SetMqttPassword} returns this
 */
proto.fbproto.SetMqttPassword.prototype.setPassword = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.SetMqttPassword} returns this
 */
proto.fbproto.SetMqttPassword.prototype.clearPassword = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.SetMqttPassword.prototype.hasPassword = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fbproto.AddDevice.prototype.toObject = function(opt_includeInstance) {
  return proto.fbproto.AddDevice.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fbproto.AddDevice} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.AddDevice.toObject = function(includeInstance, msg) {
  var f, obj = {
deviceId: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
deviceType: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
pollFrequencyS: (f = jspb.Message.getField(msg, 3)) == null ? undefined : f,
uploadFrequencyS: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fbproto.AddDevice}
 */
proto.fbproto.AddDevice.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fbproto.AddDevice;
  return proto.fbproto.AddDevice.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fbproto.AddDevice} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fbproto.AddDevice}
 */
proto.fbproto.AddDevice.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDeviceId(value);
      break;
    case 2:
      var value = /** @type {!proto.fbproto.DeviceType} */ (reader.readEnum());
      msg.setDeviceType(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPollFrequencyS(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setUploadFrequencyS(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fbproto.AddDevice.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fbproto.AddDevice.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fbproto.AddDevice} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.AddDevice.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = /** @type {!proto.fbproto.DeviceType} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeInt32(
      4,
      f
    );
  }
};


/**
 * optional int64 device_id = 1;
 * @return {number}
 */
proto.fbproto.AddDevice.prototype.getDeviceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.fbproto.AddDevice} returns this
 */
proto.fbproto.AddDevice.prototype.setDeviceId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.AddDevice} returns this
 */
proto.fbproto.AddDevice.prototype.clearDeviceId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.AddDevice.prototype.hasDeviceId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional DeviceType device_type = 2;
 * @return {!proto.fbproto.DeviceType}
 */
proto.fbproto.AddDevice.prototype.getDeviceType = function() {
  return /** @type {!proto.fbproto.DeviceType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.fbproto.DeviceType} value
 * @return {!proto.fbproto.AddDevice} returns this
 */
proto.fbproto.AddDevice.prototype.setDeviceType = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.AddDevice} returns this
 */
proto.fbproto.AddDevice.prototype.clearDeviceType = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.AddDevice.prototype.hasDeviceType = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional int32 poll_frequency_s = 3;
 * @return {number}
 */
proto.fbproto.AddDevice.prototype.getPollFrequencyS = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.fbproto.AddDevice} returns this
 */
proto.fbproto.AddDevice.prototype.setPollFrequencyS = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.AddDevice} returns this
 */
proto.fbproto.AddDevice.prototype.clearPollFrequencyS = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.AddDevice.prototype.hasPollFrequencyS = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional int32 upload_frequency_s = 4;
 * @return {number}
 */
proto.fbproto.AddDevice.prototype.getUploadFrequencyS = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.fbproto.AddDevice} returns this
 */
proto.fbproto.AddDevice.prototype.setUploadFrequencyS = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.AddDevice} returns this
 */
proto.fbproto.AddDevice.prototype.clearUploadFrequencyS = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.AddDevice.prototype.hasUploadFrequencyS = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fbproto.RemoveDevice.prototype.toObject = function(opt_includeInstance) {
  return proto.fbproto.RemoveDevice.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fbproto.RemoveDevice} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.RemoveDevice.toObject = function(includeInstance, msg) {
  var f, obj = {
deviceId: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
deviceType: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fbproto.RemoveDevice}
 */
proto.fbproto.RemoveDevice.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fbproto.RemoveDevice;
  return proto.fbproto.RemoveDevice.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fbproto.RemoveDevice} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fbproto.RemoveDevice}
 */
proto.fbproto.RemoveDevice.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDeviceId(value);
      break;
    case 2:
      var value = /** @type {!proto.fbproto.DeviceType} */ (reader.readEnum());
      msg.setDeviceType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fbproto.RemoveDevice.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fbproto.RemoveDevice.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fbproto.RemoveDevice} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.RemoveDevice.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {number} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = /** @type {!proto.fbproto.DeviceType} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional int64 device_id = 1;
 * @return {number}
 */
proto.fbproto.RemoveDevice.prototype.getDeviceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.fbproto.RemoveDevice} returns this
 */
proto.fbproto.RemoveDevice.prototype.setDeviceId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.RemoveDevice} returns this
 */
proto.fbproto.RemoveDevice.prototype.clearDeviceId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.RemoveDevice.prototype.hasDeviceId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional DeviceType device_type = 2;
 * @return {!proto.fbproto.DeviceType}
 */
proto.fbproto.RemoveDevice.prototype.getDeviceType = function() {
  return /** @type {!proto.fbproto.DeviceType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.fbproto.DeviceType} value
 * @return {!proto.fbproto.RemoveDevice} returns this
 */
proto.fbproto.RemoveDevice.prototype.setDeviceType = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.RemoveDevice} returns this
 */
proto.fbproto.RemoveDevice.prototype.clearDeviceType = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.RemoveDevice.prototype.hasDeviceType = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fbproto.AddTrigger.prototype.toObject = function(opt_includeInstance) {
  return proto.fbproto.AddTrigger.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fbproto.AddTrigger} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.AddTrigger.toObject = function(includeInstance, msg) {
  var f, obj = {
triggerId: msg.getTriggerId_asB64(),
triggerType: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f,
triggerThreshold: (f = jspb.Message.getOptionalFloatingPointField(msg, 3)) == null ? undefined : f,
sourceDeviceId: (f = jspb.Message.getField(msg, 4)) == null ? undefined : f,
targetDeviceId: (f = jspb.Message.getField(msg, 5)) == null ? undefined : f,
runTimeS: (f = jspb.Message.getField(msg, 6)) == null ? undefined : f,
cooldownS: (f = jspb.Message.getField(msg, 7)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fbproto.AddTrigger}
 */
proto.fbproto.AddTrigger.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fbproto.AddTrigger;
  return proto.fbproto.AddTrigger.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fbproto.AddTrigger} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fbproto.AddTrigger}
 */
proto.fbproto.AddTrigger.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setTriggerId(value);
      break;
    case 2:
      var value = /** @type {!proto.fbproto.TriggerType} */ (reader.readEnum());
      msg.setTriggerType(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setTriggerThreshold(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSourceDeviceId(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTargetDeviceId(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setRunTimeS(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCooldownS(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fbproto.AddTrigger.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fbproto.AddTrigger.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fbproto.AddTrigger} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.AddTrigger.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {!(string|Uint8Array)} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = /** @type {!proto.fbproto.TriggerType} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeFloat(
      3,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 6));
  if (f != null) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 7));
  if (f != null) {
    writer.writeInt32(
      7,
      f
    );
  }
};


/**
 * optional bytes trigger_id = 1;
 * @return {!(string|Uint8Array)}
 */
proto.fbproto.AddTrigger.prototype.getTriggerId = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes trigger_id = 1;
 * This is a type-conversion wrapper around `getTriggerId()`
 * @return {string}
 */
proto.fbproto.AddTrigger.prototype.getTriggerId_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getTriggerId()));
};


/**
 * optional bytes trigger_id = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getTriggerId()`
 * @return {!Uint8Array}
 */
proto.fbproto.AddTrigger.prototype.getTriggerId_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getTriggerId()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.fbproto.AddTrigger} returns this
 */
proto.fbproto.AddTrigger.prototype.setTriggerId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.AddTrigger} returns this
 */
proto.fbproto.AddTrigger.prototype.clearTriggerId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.AddTrigger.prototype.hasTriggerId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional TriggerType trigger_type = 2;
 * @return {!proto.fbproto.TriggerType}
 */
proto.fbproto.AddTrigger.prototype.getTriggerType = function() {
  return /** @type {!proto.fbproto.TriggerType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.fbproto.TriggerType} value
 * @return {!proto.fbproto.AddTrigger} returns this
 */
proto.fbproto.AddTrigger.prototype.setTriggerType = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.AddTrigger} returns this
 */
proto.fbproto.AddTrigger.prototype.clearTriggerType = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.AddTrigger.prototype.hasTriggerType = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional float trigger_threshold = 3;
 * @return {number}
 */
proto.fbproto.AddTrigger.prototype.getTriggerThreshold = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.fbproto.AddTrigger} returns this
 */
proto.fbproto.AddTrigger.prototype.setTriggerThreshold = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.AddTrigger} returns this
 */
proto.fbproto.AddTrigger.prototype.clearTriggerThreshold = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.AddTrigger.prototype.hasTriggerThreshold = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional int64 source_device_id = 4;
 * @return {number}
 */
proto.fbproto.AddTrigger.prototype.getSourceDeviceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.fbproto.AddTrigger} returns this
 */
proto.fbproto.AddTrigger.prototype.setSourceDeviceId = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.AddTrigger} returns this
 */
proto.fbproto.AddTrigger.prototype.clearSourceDeviceId = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.AddTrigger.prototype.hasSourceDeviceId = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional int64 target_device_id = 5;
 * @return {number}
 */
proto.fbproto.AddTrigger.prototype.getTargetDeviceId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.fbproto.AddTrigger} returns this
 */
proto.fbproto.AddTrigger.prototype.setTargetDeviceId = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.AddTrigger} returns this
 */
proto.fbproto.AddTrigger.prototype.clearTargetDeviceId = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.AddTrigger.prototype.hasTargetDeviceId = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional int32 run_time_s = 6;
 * @return {number}
 */
proto.fbproto.AddTrigger.prototype.getRunTimeS = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.fbproto.AddTrigger} returns this
 */
proto.fbproto.AddTrigger.prototype.setRunTimeS = function(value) {
  return jspb.Message.setField(this, 6, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.AddTrigger} returns this
 */
proto.fbproto.AddTrigger.prototype.clearRunTimeS = function() {
  return jspb.Message.setField(this, 6, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.AddTrigger.prototype.hasRunTimeS = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional int32 cooldown_s = 7;
 * @return {number}
 */
proto.fbproto.AddTrigger.prototype.getCooldownS = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.fbproto.AddTrigger} returns this
 */
proto.fbproto.AddTrigger.prototype.setCooldownS = function(value) {
  return jspb.Message.setField(this, 7, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.AddTrigger} returns this
 */
proto.fbproto.AddTrigger.prototype.clearCooldownS = function() {
  return jspb.Message.setField(this, 7, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.AddTrigger.prototype.hasCooldownS = function() {
  return jspb.Message.getField(this, 7) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fbproto.RemoveTrigger.prototype.toObject = function(opt_includeInstance) {
  return proto.fbproto.RemoveTrigger.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fbproto.RemoveTrigger} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.RemoveTrigger.toObject = function(includeInstance, msg) {
  var f, obj = {
triggerId: msg.getTriggerId_asB64(),
triggerType: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fbproto.RemoveTrigger}
 */
proto.fbproto.RemoveTrigger.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fbproto.RemoveTrigger;
  return proto.fbproto.RemoveTrigger.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fbproto.RemoveTrigger} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fbproto.RemoveTrigger}
 */
proto.fbproto.RemoveTrigger.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setTriggerId(value);
      break;
    case 2:
      var value = /** @type {!proto.fbproto.TriggerType} */ (reader.readEnum());
      msg.setTriggerType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fbproto.RemoveTrigger.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fbproto.RemoveTrigger.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fbproto.RemoveTrigger} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.RemoveTrigger.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {!(string|Uint8Array)} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeBytes(
      1,
      f
    );
  }
  f = /** @type {!proto.fbproto.TriggerType} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional bytes trigger_id = 1;
 * @return {!(string|Uint8Array)}
 */
proto.fbproto.RemoveTrigger.prototype.getTriggerId = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes trigger_id = 1;
 * This is a type-conversion wrapper around `getTriggerId()`
 * @return {string}
 */
proto.fbproto.RemoveTrigger.prototype.getTriggerId_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getTriggerId()));
};


/**
 * optional bytes trigger_id = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getTriggerId()`
 * @return {!Uint8Array}
 */
proto.fbproto.RemoveTrigger.prototype.getTriggerId_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getTriggerId()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.fbproto.RemoveTrigger} returns this
 */
proto.fbproto.RemoveTrigger.prototype.setTriggerId = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.RemoveTrigger} returns this
 */
proto.fbproto.RemoveTrigger.prototype.clearTriggerId = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.RemoveTrigger.prototype.hasTriggerId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional TriggerType trigger_type = 2;
 * @return {!proto.fbproto.TriggerType}
 */
proto.fbproto.RemoveTrigger.prototype.getTriggerType = function() {
  return /** @type {!proto.fbproto.TriggerType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.fbproto.TriggerType} value
 * @return {!proto.fbproto.RemoveTrigger} returns this
 */
proto.fbproto.RemoveTrigger.prototype.setTriggerType = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.RemoveTrigger} returns this
 */
proto.fbproto.RemoveTrigger.prototype.clearTriggerType = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.RemoveTrigger.prototype.hasTriggerType = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.fbproto.SetEncKey.prototype.toObject = function(opt_includeInstance) {
  return proto.fbproto.SetEncKey.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fbproto.SetEncKey} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.SetEncKey.toObject = function(includeInstance, msg) {
  var f, obj = {
encryptionKey: msg.getEncryptionKey_asB64()
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fbproto.SetEncKey}
 */
proto.fbproto.SetEncKey.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.fbproto.SetEncKey;
  return proto.fbproto.SetEncKey.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fbproto.SetEncKey} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fbproto.SetEncKey}
 */
proto.fbproto.SetEncKey.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!Uint8Array} */ (reader.readBytes());
      msg.setEncryptionKey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.fbproto.SetEncKey.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.fbproto.SetEncKey.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fbproto.SetEncKey} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.fbproto.SetEncKey.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {!(string|Uint8Array)} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeBytes(
      1,
      f
    );
  }
};


/**
 * optional bytes encryption_key = 1;
 * @return {!(string|Uint8Array)}
 */
proto.fbproto.SetEncKey.prototype.getEncryptionKey = function() {
  return /** @type {!(string|Uint8Array)} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * optional bytes encryption_key = 1;
 * This is a type-conversion wrapper around `getEncryptionKey()`
 * @return {string}
 */
proto.fbproto.SetEncKey.prototype.getEncryptionKey_asB64 = function() {
  return /** @type {string} */ (jspb.Message.bytesAsB64(
      this.getEncryptionKey()));
};


/**
 * optional bytes encryption_key = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getEncryptionKey()`
 * @return {!Uint8Array}
 */
proto.fbproto.SetEncKey.prototype.getEncryptionKey_asU8 = function() {
  return /** @type {!Uint8Array} */ (jspb.Message.bytesAsU8(
      this.getEncryptionKey()));
};


/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.fbproto.SetEncKey} returns this
 */
proto.fbproto.SetEncKey.prototype.setEncryptionKey = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.fbproto.SetEncKey} returns this
 */
proto.fbproto.SetEncKey.prototype.clearEncryptionKey = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.fbproto.SetEncKey.prototype.hasEncryptionKey = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * @enum {number}
 */
proto.fbproto.Error = {
  ERROR_NONE: 0,
  ERROR_INVALID_DEVICEID: 1,
  ERROR_INVALID_CONTROLLERID: 2,
  ERROR_INCORRECT_DEVICETYPE: 3,
  ERROR_DEVICE_NOT_CONNECTED: 4,
  ERROR_INVALID_PH: 5,
  ERROR_GENERAL: 1024
};

/**
 * @enum {number}
 */
proto.fbproto.ControllerType = {
  CT_NONE: 0,
  CT_DEVKIT1: 1,
  CT_TEST: 2,
  CT_PROTOTYPEA: 3,
  CT_PROTOTYPEB: 4,
  CT_RPI: 5,
  CT_C1_091: 6,
  CT_MAX: 7
};

/**
 * @enum {number}
 */
proto.fbproto.NodeType = {
  NT_NONE: 0,
  NT_PH: 1,
  NT_EC: 2,
  NT_TEMPERATURE: 3,
  NT_HUMIDITY: 4,
  NT_CO2: 5,
  NT_PUMP: 6,
  NT_VALVE: 7,
  NT_FAN: 8,
  NT_POWER: 9,
  NT_MOISTURE: 10,
  NT_RELAY: 11,
  NT_GT: 101,
  NT_LT: 102,
  NT_TIMER: 103,
  NT_DELAY: 104,
  NT_UPLOAD: 105,
  NT_DAILY_ON: 106,
  NT_DAILY_ENABLE: 107,
  NT_MAX: 108
};

/**
 * @enum {number}
 */
proto.fbproto.DeviceAssemblyType = {
  DAT_NONE: 0,
  DAT_PH_GENERIC: 1,
  DAT_EC_GENERIC: 2,
  DAT_TEMPERATURE_GENERIC: 3,
  DAT_HUMIDITY_GENERIC: 4,
  DAT_CO2_GENERIC: 5,
  DAT_PUMP_GENERIC: 6,
  DAT_VALVE_GENERIC: 7,
  DAT_FAN_GENERIC: 8,
  DAT_POWER_GENERIC: 9,
  DAT_MOISTURE_GENERIC: 10,
  DAT_RELAY_GENERIC: 11,
  DAT_AM2301B: 201,
  DAT_ACD1100: 202,
  DAT_ZTS3002: 203,
  DAT_MAX: 204
};

/**
 * @enum {number}
 */
proto.fbproto.DeviceType = {
  DT_NONE: 0,
  DT_PH: 1,
  DT_EC: 2,
  DT_TEMPERATURE: 3,
  DT_HUMIDITY: 4,
  DT_CO2: 5,
  DT_PUMP: 6,
  DT_VALVE: 7,
  DT_FAN: 8,
  DT_POWER: 9,
  DT_MOISTURE: 10,
  DT_RELAY: 11,
  DT_MAX: 12
};

/**
 * @enum {number}
 */
proto.fbproto.ReadingType = {
  RT_NONE: 0,
  RT_PH: 1,
  RT_EC: 2,
  RT_TEMPERATURE: 3,
  RT_HUMIDITY: 4,
  RT_CO2: 5,
  RT_POWER: 9,
  RT_MOISTURE: 10,
  RT_MAX: 11
};

/**
 * @enum {number}
 */
proto.fbproto.TriggerType = {
  TRIGGER_NONE: 0,
  TRIGGER_GREATER_THAN: 1,
  TRIGGER_EQUAL: 2,
  TRIGGER_LESS_THAN: 3
};

goog.object.extend(exports, proto.fbproto);
